// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%0A%3Csvg width=%2716%27 height=%2737%27 viewBox=%270 0 16 37%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M10.5 36.5L16 31L10.5 25.5L9.09 26.91L12.17 30L6.5 30C4 30 2.00001 28 2.00001 25.5L2 -8.74228e-08L0 0L6.99382e-06 25.5C7.15075e-06 29.09 2.91 32 6.5 32L12.17 32L9.08 35.09L10.5 36.5Z%27 fill=%27%23E0E0E0%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  color: #4a4a4a;
  overflow-x: hidden;
}
b,
strong {
  font-weight: 600 !important;
}
h2 small {
  font-size: 14px;
  display: block;
  line-height: 24px;
  color: #979797;
}
textarea[readonly] {
  font-size: 12px;
  font-family: "Open Sans";
  color: #828282;
}
.square input[type="radio"] {
  border-radius: 4px;
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 0px 1px #c4c4c4;
  margin-top: 5px;
}
.square input[type="radio"]:checked {
  background-color: #4a4a4a;
  background-image: none;
}
.square .form-check-label {
  font-size: 13px;
  color: #9b9b9b;
}
.container,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  max-width: 1260px;
}
.hiddenElement {
  opacity: 0 !important;
  position: fixed !important;
  left: -500px !important;
  top: -500px !important;
  z-index: -99999 !important;
  width: 1px !important;
  height: 1px !important;
  overflow-x: hidden !important;
}
.txtCenter {
  text-align: center;
}
.txtLeft {
  text-align: left !important;
}
.customLabel {
  font-size: 13px;
}
.customAnchor {
  color: #2f80ed !important;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}
.customAnchor:last-child {
  border: none;
}
.customAnchor.red {
  color: #f55b4f !important;
}
.customAnchor.light {
  color: #bdbdbd !important;
}
.txtRight {
  text-align: right;
}
.sucessMsg,
.success {
  position: fixed;
  left: 20px;
  bottom: 20px;
  padding: 20px;
  background: #40a540;
  color: #fff;
  border-radius: 5px;
  z-index: 9999;
  width: auto;
}
.fail {
  position: fixed;
  left: 20px;
  bottom: 20px;
  padding: 20px;
  background: #f55b4f;
  color: #fff;
  border-radius: 5px;
  z-index: 9999;
}
a {
  text-decoration: none;
  display: block;
  cursor: pointer;
  color: inherit;
}
.h5,
h5 {
  color: #4a4a4a;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 19px;
}
.h5 a:hover,
h5 a:hover {
  color: #4a4a4a;
}
.h6,
h6 {
  color: #333333;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  word-wrap: break-word;
}
.validation-error {
  font-size: 13px;
  color: #f00;
  margin: 10px 0;
}
label {
  font-size: 18px;
}
input {
  max-width: 100%;
}
input[type="text"] {
  background: #fcfcfc;
  border: 1px solid #ced4da;
  border-radius: 3px;
  padding: 8px;
}
input[type="checkbox"] {
  margin: 10px 18px;
  padding: 7px;
}
.fieldInfo {
  color: #9b9b9b;
  font-size: 13px;
  font-weight: 400;
}
.loading > *:not(.sucessMsg),
.formSubmitting > *:not(.sucessMsg) {
  opacity: 0.5;
}
select.selectfield {
  border: 1px solid #e0e0e0;
  background: #ffffff;
  padding: 8px 15px 8px 10px;
  border-radius: 5px;
  width: 240px;
  margin: 0 15px 0 0;
  appearance: auto;
  font-size: 13px;
  font-family: "Open Sans";
}
.btn {
  padding: 10px 30px;
  white-space: nowrap;
}
.btn:hover {
  box-shadow: 0 0 5px 0px #959595;
}
.btn-secondary {
  background-color: #828282;
  border-color: #828282;
}
.btn-secondary-light {
  background: #f2f2f2;
}
.btn.btn-md {
  font-size: 12px;
}
.btn.orange {
  background: #f2994a !important;
  border-color: #f2994a;
}
.modal-header {
  background: #f9f9f9;
  border: 0px;
  padding: 20px 30px;
}
.modal-body {
  max-width: 550px;
  margin: 50px auto;
  width: 100%;
}
.modal-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  font-family: "Open Sans";
}
.table.tableCommon > :not(:first-child) {
  border: inherit;
}
header,
footer {
  background: #000000;
}
header {
  position: sticky;
  z-index: 10;
  left: 0px;
  top: 0px;
}
header .navbar-brand {
  margin: 22px 0;
  height: 38px;
  display: inline-block;
  padding: 0;
}
header .navbar-brand > img {
  max-height: 100%;
  margin: 0;
  filter: invert(1);
}
header .header-right-col {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  position: relative;
  z-index: 2;
}
header .avatarSection .user-avatar {
  position: relative;
  display: block;
}
header .avatarSection .user-avatar svg {
  position: absolute;
  right: 1px;
  bottom: 1px;
  background: #ffffff;
  border-radius: 100%;
  height: 13px;
  width: 13px;
}
header .avatarSection .user-handle {
  font-size: 14px;
  color: #9b9b9b;
  display: block;
}
header .userDropDown {
  position: absolute;
  right: -5px;
  background: #fff;
  top: 6px;
  padding: 20px;
  border-radius: 7px;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
header .userDropDown a {
  color: #2f80ed;
}
header .userDropDown button {
  width: 250px;
}
.fa-question-circle {
  font-size: 20px !important;
  margin: 20px;
  color: #4a4a4a;
}
header .user-avatar img,
header .user-avatar svg {
  width: 45px;
  height: 45px;
  font-size: 45px;
}
form#search {
  position: relative;
  min-width: 300px;
}
form#search input[type="text"] {
  height: 40px;
  width: 100%;
  padding-right: 40px;
  border: none;
  background: #f6f6f6;
  font-size: 13px;
  font-family: "Open Sans";
}
form#search button {
  background: none;
  border: none;
  position: absolute;
  color: #9b9b9b;
  top: 2px;
  right: 6px;
}
form#search button i {
  font-size: 21px;
}
form#search.searchForm1 {
  min-width: 100px;
  width: 380px;
  max-width: 100%;
}
.display-inline {
  display: inline;
}

#role-filter {
  background: #fcfcfc;
  border: 1px solid #ced4da;
  border-radius: 3px;
  padding: 7px;
}
main.body {
  min-height: calc(100vh - 130px);
}
.main-left-col {
  border-right: 2px solid #f1f1f1;
  padding: 0;
}
.main-left-col aside {
  position: sticky;
  top: 82px;
  left: 0;
  z-index: 1;
}
.main-right-col {
  /*min-height: 100vh;*/
  background: #ffffff;
}
main.body aside {
  height: calc(100vh - 82px);
  overflow: auto;
}
main.body aside h2 {
  font-size: 15px;
  line-height: 19px;
  color: #4a4a4a;
  margin: 0;
}

main.body aside .dropdown button.dropdown-toggle,
.standard-dropdown button.dropdown-toggle {
  width: 100%;
  background: none !important;
  text-align: left;
  box-shadow: none !important;
  color: #000 !important;
  font-weight: 600 !important;
  font-size: 13px;
  padding: 10px 40px 10px 12px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0 !important;
  word-break: break-word !important;
  white-space: break-spaces;
}

.standard-dropdown .dropdown-menu {
  overflow: auto;
  min-width: 100%;
  padding-top: 0px;
  max-height: 300px;
}
.standard-dropdown .dropdown-menu .dropdown-item {
  font-size: 13px;
}

.menuToggle {
  cursor: pointer;
}

main.body aside nav ul li a.active i,
main.body aside nav ul li a.active svg path {
  color: #2f80ed;
  fill: #2f80ed;
  stroke: #2f80ed;
}
main.body aside nav ul li i,
main.body aside nav ul li svg {
  font-size: 24px;
  vertical-align: middle;
  color: #979797;
  width: 30px !important;
  text-align: center;
}

main.body section {
  padding-top: 20px;
  padding-left: 18px;
  margin-bottom: 100px;
}
main.body section h2 {
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  color: #4a4a4a;
  font-family: Open Sans;
}
main.body section h3 {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  font-family: "Open Sans";
}
main.body section h3.lightColor,
.modal-content h3.lightColor {
  font-size: 18px;
  color: #979797;
  font-family: "open sans";
  font-weight: 600;
}
main.body section .title-section {
  margin-bottom: 40px;
}
footer .footer-right-col {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
footer .footer-left-col span {
  color: #ffffff;
  font-size: 16px;
  line-height: 20px;
}
footer .footer-right-col ul {
  list-style: none;
  font-size: 14px;
  margin: 0 !important;
}
footer .footer-right-col ul li {
  display: inline-block;
  color: #ffffff;
}
footer .footer-right-col ul li a {
  color: #ffffff;
  text-decoration: none;
}
footer .footer-right-col ul li a:hover {
  color: #b9b9b9;
}

/* User listing */
table.tableCommon th {
  font-size: 11px;
  line-height: 13px;
  color: #9b9b9b;
  font-weight: normal;
  text-transform: uppercase;
  padding: 5px 5px;
  font-weight: 600;
  vertical-align: middle;
  font-family: "Open Sans";
}
div.author {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
div.author .copy-wrap {
  margin-left: 10px;
  line-height: 1;
}
div.author .copy-wrap .authorhandle {
  font-size: 13px;
}
.img-circle.avatar {
  /*height: 44px;
  width: 44px;*/
  height: 38px;
  width: 38px;
  min-width: 38px;
  border: 2px solid #9b9b9b;
  background-color: #ffffff;
  object-fit: cover;
  display: block;
  border-radius: 50%;
  /*padding: 2px;*/
  padding: 0px;
}
.img-circle.avatar.avatar-lg {
  width: 45px;
  height: 45px;
}
div.author .small-dp,
div.reprted-profile-author .small-dp {
  position: relative;
}
div.author .small-dp svg {
  position: absolute;
  right: 0px;
  bottom: 0px;
  background: #ffffff;
  border-radius: 100%;
}
div.author .user-color-green {
  color: #2aa974;
}
div.author .user-color-blue {
  color: #2f80ed;
}
div.author .user-color-green .img-circle.avatar {
  border-color: #2aa974;
}
div.author .user-color-blue .img-circle.avatar {
  border-color: #2f80ed;
}
a.authorname h6 {
  margin: 0;
  padding: 0;
}
a.authorhandle {
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  color: #9b9b9b;
}

div.author.medium .img-circle.avatar {
  height: 52px;
  width: 52px;
}
div.author.medium a.authorname h6 {
  font-size: 24px;
  line-height: 32px;
}
div.author.medium a.authorhandle {
  font-size: 14px;
  line-height: 20px;
}
table.tableCommon th svg {
  vertical-align: initial;
}
table.tableCommon th.ASC svg {
  transform: rotate(180deg);
}
table.tableCommon td .svg {
  width: 16px !important;
  height: 16px !important;
}
table.tableCommon td {
  font-size: 12px;
  padding: 15px 5px;
}
table.tableCommon th:not(:first-child),
table.tableCommon td:not(:first-child) {
  text-align: center;
  vertical-align: middle;
}
table.network-users th:nth-child(2),
table.network-users td:nth-child(2) {
  text-align: left;
  padding-left: 10px;
}
table.tableCommon td strong {
  font-size: 14px;
  display: block;
}
.verified-green,
.usercheck-green {
  color: #2aa974;
}
.verified-blue,
.usercheck-blue {
  color: #2f80ed;
}
.verified-false,
.usercheck-false {
  color: #dbdbdb;
}
.AuthorSettings {
  margin-top: 50px;
}
.AuthorSettings .form-group {
  padding: 25px 15px !important;
  margin: 0;
  border-bottom: 1px solid #f2f2f2 !important;
}

.AuthorSettings .addNetworkField {
  position: relative;
}
.AuthorSettings i {
  position: absolute;
  right: 0;
  padding: 8px;
  font-size: 18px;
  color: #9b9b9b;
}
.AuthorSettings .buttons {
  position: absolute;
  right: 22px;
  top: -156px;
}
.toggle-checkbox {
  float: right;
  position: relative;
}
.toggle-checkbox:before {
  background: #e9e9eb;
  content: "";
  width: 50px;
  height: 30px;
  display: block;
  border-radius: 20px;
  position: absolute;
  right: -20px;
  top: -10px;
  transition: all 0.1s ease-in-out;
}
.toggle-checkbox:after {
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  background: #ffffff;
  position: absolute;
  border-radius: 20px;
  right: 2px;
  top: -8px;
  transition: all 0.1s ease-in-out;
  box-shadow: 5px 0px 10px 0px #c3c3c3;
}
.toggle-checkbox:checked:before {
  background: #34c759;
}
.toggle-checkbox:checked:after {
  right: -18px;
  box-shadow: none;
}

.toggle-checkbox.small:before {
  width: 40px;
  height: 24px;
  top: -6px;
  right: -14px;
}
.toggle-checkbox.small:after {
  width: 20px;
  height: 20px;
  right: 4px;
  top: -4px;
}
.toggle-checkbox.small:checked:after {
  right: -12px;
}
.AuthorSettings .buttons {
  text-align: center;
}
.common-form .buttons .btn-secondary {
  background: #ffffff;
  color: #828282;
  border-color: #bdbdbd;
  margin: 50px 8px 0;
}
.common-form .buttons .btn-primary {
  margin: 50px 8px 0;
}
.common-form .buttons .btn {
  font-size: 16px;
  line-height: 22px;
  border-radius: 5px;
  font-weight: 400;
}

.btn.btn-primary {
  background: #2f80ed;
}
.btn-outline-primary {
  border-color: #2f80ed;
  color: #2f80ed;
}
.btn.btn-primary.light {
  background: #60a4e9;
  border-color: #60a4e9;
}
.btn.btn-secondary.light {
  background: #f2f2f2;
  border-color: #f2f2f2;
  color: #4a4a4a;
}
.btn.btn-sm {
  padding: 0.3rem 0.5rem;
  font-size: 12px;
  line-height: 18px;
  font-family: "Open Sans";
}

.network-favicon {
  width: 30px;
}
span.networkname {
  display: block;
  font-size: 15px;
  font-weight: 600;
}
/*.debDeployModal .modal-body , .removeDebModal .modal-body{
  width: 550px;
    max-width: 100%;
    margin: 0 auto;
}*/
.DeployDebateForm .form-group {
  padding: 10px 0;
}
.DeployDebateTabs.nav-tabs {
  border: none;
}
.DeployDebateTabs.nav-tabs .nav-link {
  border: none;
  border-radius: 5px;
  padding: 10px 30px;
  background: #f6f6f6;
  color: #828282;
}
.DeployDebateTabs.nav-tabs .nav-link.active {
  color: #fff;
  background: #828282;
}
.DeployDebateTabs.nav-tabs .nav-link:first-child {
  margin-right: 10px;
}
.debate-image {
  margin-left: 15px;
}
.debate-image img {
  background: #d8d8d8;
  width: 100px !important;
  height: 65px !important;
  object-fit: cover;
}
.debateDefaultImg {
  background: #d8d8d8;
  width: 100px !important;
  height: 65px !important;
  object-fit: cover;
}
h6.debatename {
  font-weight: 400;
  font-size: 13px;
  text-align: left;
  margin: 0;
}
i.debStatus {
  width: 13px;
  height: 13px;
  display: inline-block;
  border-radius: 50%;
  background: #f2f2f2;
}
i.debStatus.active {
  background: #27ae60;
}
.listItem7 {
  display: inline-block;
  padding: 0 10px;
  border-right: 1px solid #ccc;
  font-size: 11px;
  line-height: 14px;
}
.listItem7:nth-of-type(1) {
  padding-left: 0;
}
.listItem7:last-child {
  border-right: 0;
  padding-right: 0;
}

.card.widget-flat {
  background: #f6f6f6;
  border: 1px solid #f6f6f6;
  border-radius: 8px;
}
h5.analyTitle1 {
  font-size: 12px;
  font-weight: 700;
  height: 40px;
  text-transform: uppercase;
  margin: 0 0 5px 0;
  display: flex;
  align-items: center;
}
h5.analyTitle1 > i.fa,
h5.analyTitle1 > svg {
  color: #9b9b9b;
  font-size: 20px;
  margin: 0 8px 0 0;
}
h3.analyNum1 {
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  color: #2f80ed;
  text-transform: uppercase;
  margin: 0;
}
.analyNumInf {
  text-align: center;
  color: #979797;
  font-size: 14px;
  height: 20px;
}
.analyTabInf {
  font-size: 11px;
  color: #9b9b9b;
  margin: 0;
}
.analyTabInf i.fa-caret-up,
.analyTabInf i.fa-caret-down {
  font-size: 18px;
  vertical-align: bottom;
  margin: 0 0 0 3px;
}
.analyTabInf i.fa-caret-up {
  color: #2aa974;
}
.analyTabInf i.fa-caret-down {
  color: #ce0b47;
}
.dropdown9 .dropdown-menu {
  padding: 0.3rem 0;
}
.dropdown9 .dropdown-item {
  font-size: 13px;
  padding: 0.5rem 1rem;
}

/* Loader css */

.loader-top {
  background-color: #fff;
  height: 100%;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1111;
}

.loader-top.absolute {
  z-index: 5;
  position: absolute;
}
.loader-top.transparent {
  background: rgba(255, 255, 255, 0.5);
}

.cssload-container {
  display: block;
  width: 120px;
  left: 50%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.cssload-container.loadMore {
  position: static;
  text-align: center;
  margin: 0 auto;
  transform: none;
}

.cssload-container img {
  max-width: 100%;
  margin-bottom: 20px;
}

.cssload-loading {
  margin-left: 10px;
}

.cssload-loading i {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 50%;
  background: #333;
}

.cssload-loading i:first-child {
  opacity: 0;
  animation: cssload-loading-ani2 1s linear infinite;
  -o-animation: cssload-loading-ani2 1s linear infinite;
  -ms-animation: cssload-loading-ani2 1s linear infinite;
  -webkit-animation: cssload-loading-ani2 1s linear infinite;
  -moz-animation: cssload-loading-ani2 1s linear infinite;
  transform: translate(-19px);
  -o-transform: translate(-19px);
  -ms-transform: translate(-19px);
  -webkit-transform: translate(-19px);
  -moz-transform: translate(-19px);
}

.cssload-loading i:nth-child(2),
.cssload-loading i:nth-child(3) {
  animation: cssload-loading-ani3 1s linear infinite;
  -o-animation: cssload-loading-ani3 1s linear infinite;
  -ms-animation: cssload-loading-ani3 1s linear infinite;
  -webkit-animation: cssload-loading-ani3 1s linear infinite;
  -moz-animation: cssload-loading-ani3 1s linear infinite;
}

.cssload-loading i:last-child {
  animation: cssload-loading-ani1 1s linear infinite;
  -o-animation: cssload-loading-ani1 1s linear infinite;
  -ms-animation: cssload-loading-ani1 1s linear infinite;
  -webkit-animation: cssload-loading-ani1 1s linear infinite;
  -moz-animation: cssload-loading-ani1 1s linear infinite;
}

@keyframes cssload-loading-ani1 {
  100% {
    transform: translate(39px);
    opacity: 0;
  }
}

@keyframes cssload-loading-ani2 {
  100% {
    transform: translate(19px);
    opacity: 1;
  }
}

@keyframes cssload-loading-ani3 {
  100% {
    transform: translate(19px);
  }
}

.pagination {
  justify-content: center;
}
.pagination li {
  border: 1px solid #2f80ed;
  margin: 0 3px;
  border-radius: 2px;
}
.pagination li a {
  padding: 0 5px;
}
.pagination li.active {
  background: #2f80ed;
  color: #fff;
}
li.previous,
li.next {
  font-size: 25px;
  line-height: 18px;
}
li.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.authContainer {
  /*height: 100vh;
  overflow: hidden;*/
}
.authTopFav {
  width: 86px;
  height: 86px;
  margin-bottom: 20px;
}
.authTopLogo {
  height: 40px;
  width: auto;
  max-width: 150px;
  display: block;
  margin: 0 auto;
}
.login-div {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 30px);
  align-items: center;
  margin: 15px auto;
  opacity: 0;
  transition: opacity ease-in-out 0.5s;
}
.loaded-true {
  opacity: 1;
}
.login-div .logo-section {
  margin-bottom: 40px;
}
.login-div .logo-section h1 {
  font-weight: 800;
  letter-spacing: -2px;
  font-family: sans-serif;
  font-size: 48px;
  color: #000000;
}
.login-container {
  border: 1px solid #d5d5d5;
  padding: 50px 20px;
  border-radius: 10px;
  background: #f9f9f9;
  width: 630px;
  text-align: center;
}
.login-div fieldset {
  position: relative;
  max-width: 360px;
  width: 100%;
  display: block;
  margin: 0 auto 20px;
}
.login-div i {
  position: absolute;
  left: 15px;
  top: 17px;
  color: #dbdbdb;
}
.login-div input {
  padding: 12px 12px 12px 35px;
  font-size: 16px;
  color: #4a4a4a !important;
  border-radius: 5px;
}
.login-div button {
  max-width: 333px;
  width: 100%;
  font-weight: 500;
  border-radius: 5px;
}

.inline-content {
  display: flex;
  justify-content: space-between;
}

.inline-content.top {
  align-items: start;
}
.inline-content.middle {
  align-items: center;
}
.inline-content.bottom {
  align-items: end;
}
.WLSettings .buttons {
  position: absolute;
  top: -85px;
  right: 0;
}
.addNetwork .buttons {
  top: -90px;
}
.common-form:not(.AuthorSettings, .DeployDebateForm) label:not(.sub-label) {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: #4a4a4a;
  margin-bottom: 5px;
  display: block;
  font-family: "Open Sans";
}
.common-form .form-group {
  border: none;
  padding-top: 5px;
  padding-bottom: 15px;
  margin: 0;
}

.sided-form .form-control {
  padding: 8px;
  background: #ffffff;
  font-size: 13px;
  line-height: 19px;
  font-family: "Open sans";
}

.WLSettings .form-control,
.profileForm .form-control {
  font-size: 14px;
  line-height: 22px;
  padding: 13px;
  background: #fcfcfc;
}
.WLSettings .form-group input[type="checkbox"] {
  float: none;
}

.WLSettings .buttons {
  text-align: right;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

.WLSettings .buttons .btn-primary {
  margin: 10px 0 0 0;
}

.WLSettings .buttons .btn-secondary {
  margin: 10px 8px 0 0;
}

.common-form .form-group select {
  padding: 8px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  color: #4e4e4e;
  width: 100%;
  appearance: auto;
  -webkit-appearance: auto;
}
.WLSettings h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #979797 !important;
  margin: 0;
}
.WLSettings .addCatField,
.WLSettings .addPlacementField {
  position: relative;
}
.WLSettings .addCatField .btn,
.WLSettings .addPlacementField .btn {
  position: absolute;
  right: 3px;
}
.WLSettings .catCols .form-group {
  position: relative;
  padding: 28px 0;
}
.WLSettings .catCols .form-group span {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
}

.WLSettings .placementCols {
  padding: 12px 10px;
  border-bottom: 1px solid #f2f2f2;
}
.WLSettings .placementCols .fa-code {
  font-size: 20px;
  color: #dbdbdb;
}
.WLSettings .catImageCol {
  width: 30px;
  overflow-x: hidden;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 0;
  height: auto;
}
.WLSettings .catImageCol i.fa-upload {
  position: absolute;
  right: 0;
  left: 0;
  z-index: -1;
  max-width: 100%;
  height: auto;
  text-align: center;
}
.WLSettings .catImageCol span.close {
  top: -5px;
  right: -1px;
}
.WLSettings .catTextCol {
  max-width: 32%;
}
.WLSettings .catTextCol input[type="text"],
.WLSettings .placementCols input[type="text"] {
  border: none;
  background: transparent;
}
.WLSettings .catReorderCol {
  width: 25px;
  overflow-x: hidden;
  text-align: right;
}
.WLSettings .catCols {
  border-bottom: 1px solid #f2f2f2;
}
.WLSettings .catCols i {
  color: #dbdbdb;
  font-size: 20px;
}
.inline-toggles .form-group {
  width: 33%;
  display: inline-block;
  vertical-align: bottom;
  text-align: center;
}

.inline-fieldGroups .form-group {
  width: 50%;
  display: inline-block;
  vertical-align: bottom;
  text-align: left;
}
.WLSettings .catCols input.form-control-file {
  opacity: 0;
  cursor: pointer;
}

.WLSettings .field-logo {
  width: 100%;
  height: 15vw;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WLSettings .field-favicon {
  width: 100%;
  height: 10vw;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WLSettings .field-emaillogo {
  width: 100%;
  height: 10vw;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-field-wrap {
  position: relative;
  width: 100%;
  height: 7vw;
}
.img-field-wrap input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.img-field-wrap img,
.img-field-placeholder {
  position: absolute;
  z-index: 0;
  text-align: center;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  flex-direction: column;
}
.img-field-wrap span.close {
  position: absolute;
  right: 10px;
  top: 3px;
  z-index: 1;
  color: #dbdbdb;
  cursor: pointer;
}
.img-field-placeholder * {
  display: block;
  color: #dbdbdb;
}
.img-field-placeholder i {
  font-size: 18px;
}
.img-field-placeholder span {
  font-size: 14px;
  line-height: 18px;
}
.img-field-placeholder .upload-label {
  color: #2f80ed;
}

.joinedNetworksWrap {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  padding-bottom: 1px;
  min-height: 42px;
}
.joinedNetworksWrap:hover {
  overflow-x: scroll;
}
span.joinedNetworks {
  display: inline-flex;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  background: #fff;
  padding: 5px 10px;
  margin-right: 7px;
  margin-bottom: 0;
  cursor: pointer;
  vertical-align: middle;
  font-size: 14px;
  align-items: center;
}
span.joinedNetworks input[type="radio"] {
  opacity: 0;
  position: absolute;
}
span.joinedNetworks i,
span.joinedNetworks img,
span.joinedNetworks svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 100%;
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
}
.joinedNetworksWrap input[type="radio"] {
  position: absolute;
  opacity: 0;
}
input[type="radio"]:checked + span.joinedNetworks {
  background: #2f80ed;
  color: #ffffff;
}

.deleteUser {
  color: #e33628;
  font-size: 18px;
  cursor: pointer;
}

main.collapsed .main-left-col {
  width: 85px;
  padding: 0;
}
main.collapsed .main-right-col {
  width: calc(100% - 100px);
  overflow-x: auto;
}

main.collapsed aside,
main.collapsed aside nav ul li {
  text-align: center !important;
}
main.collapsed aside nav ul li a span,
main.collapsed aside nav ul li h2 {
  display: none;
}
main.collapsed aside nav ul li a {
  padding-left: 10px;
  text-align: center;
  display: block;
  border: 0px solid transparent !important;
}
main.collapsed aside nav.leftMenu ul {
  margin-left: -15px;
}
main.collapsed aside nav ul li .menuToggle {
  transform: rotate(180deg);
  margin-left: 0 !important;
}
main.collapsed aside .current-network-section .dropdown button.dropdown-toggle {
  font-size: 0;
  padding: 8px 5px !important;
  width: 30px;
}
main.collapsed
  aside
  .current-network-section
  .dropdown
  button.dropdown-toggle:after {
  position: static !important;
  font-size: 12px;
}
main.body.collapsed .current-network-section {
  padding-right: 0.25rem !important;
}
main.body.collapsed aside nav ul li i,
main.body.collapsed aside nav ul li svg {
  margin-right: 0;
}

.badge {
  border-radius: 1rem;
  font-weight: 400;
  letter-spacing: 0.5px;
}
.badge-success {
  color: #fff;
  background: #2aa974;
}
.badge-primary {
  color: #fff;
  background-color: #007bff;
}
.badge-danger {
  color: #fff;
  background-color: #dc3545;
}
.badge-light {
  color: #212529;
  background-color: #e4e4e4;
}
.mr1 {
  margin-right: 4px;
}
.debateTitle9 {
  color: #9b9b9b;
  font-size: 11px;
}
.debateTitle9 svg.svg,
table.tableCommon td .debateTitle9 svg.svg {
  width: 12px !important;
  height: 12px !important;
  color: #d8d8d8;
}
a.linkActive {
  color: #2f80ed;
}
a.linkInactive {
  color: #bdbdbd !important;
  cursor: context-menu;
  border-color: #bdbdbd !important;
  pointer-events: none;
}

.datePickerWrapper {
  position: relative;
}
.datePickerWrapper i {
  position: absolute;
  right: 10px;
  top: calc(50% - 8px);
}
.startDebate .buttons .btn {
  width: 50%;
  padding: 15px;
}
.startDebate .form-control.datepickerField {
  padding-left: 10px;
  padding-right: 32px;
}
.startDebate .form-control {
  padding: 8px;
  background: #ffffff;
  font-size: 13px;
  line-height: 19px;
  font-family: "Open sans";
}
.startDebate .side .form-control {
  border: 0px solid #999;
  border-left-width: 5px;
  border-radius: 5px;
  padding: 9px;
  padding-right: 60px;
}
.startDebate .side .form-control.removeBtnOn {
  padding-right: 120px;
}
.startDebate .side {
  padding-bottom: 10px;
}
.startDebate .side .message {
  padding: 12px 14px;
  background: #f5f5f5;
  border-radius: 4px;
}
.startDebate textarea.form-control[name="background"] {
  height: 120px;
}
.startDebate textarea.form-control {
  max-height: 120px !important;
}
.startDebate .field-backgroundImage {
  width: 100%;
  height: 7vw;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f6f6;
  max-height: 235px;
  position: absolute;
}
.startDebate .delete-side {
  /*position: absolute;
  right: 5px;
  top: 0;*/
}
.startDebate .delete-button {
  font-size: 11px;
  font-weight: 400;
}
.startDebate .sideP {
  padding-right: 60px;
}
.startDebate .sideP + i {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  color: #bdbdbd;
}
.startDebate .side-inline-items {
  position: absolute;
  right: 7px;
  top: 6px;
  height: 100%;
}
.addNetworkField input[type="text"] {
  border: none;
  background: #f6f6f6;
}
.searchWrapper {
  position: relative;
}
.searchResultList {
  position: absolute;
  left: 0;
  right: 0;
  background: #f6f6f6;
  padding: 10px;
  max-height: 124px;
  overflow: hidden;
  overflow-y: auto;
}
.loading *,
.formSubmitting * {
  pointer-events: none !important;
}

.modal-body {
  max-width: 100%;
}
.modalContentWrapper {
  max-width: 600px;
  margin: 0 auto;
}

.votesPercentage {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 13px;
  font-weight: 600;
  height: 100%;
  display: flex;
  align-items: center;
}
.percentageBar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
label .fa-lock {
  font-size: 17px;
  color: #9b9b9b;
  margin-left: 5px;
}
.debatePreviewSection {
  padding: 25px 0;
  background: #f6f6f6;
  border-radius: 10px;
}
.debatePreviewInner {
  border-radius: 10px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0px 0px 6px 0px #0000001a;
  max-width: 334px;
  margin: 0 auto;
}
.debatePreviewBgImg img {
  max-width: 100%;
  border-radius: 6px;
  border: 1px solid #e7e7e7;
  padding: 0px;
  height: 150px;
  width: 100%;
  object-fit: cover;
}
.debatePreviewTitle h5,
.debatePreviewSides label {
  color: #333333 !important;
}
.debatePreviewTitle p {
  padding: 7px;
  background: #efefef;
  margin-bottom: 7px;
}
.lightColorSpan {
  font-size: 13px;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
  font-family: "Open Sans";
}
.lightColorSpan.large {
  font-size: 16px;
}
.lightColorSpan.small {
  font-size: 11px;
}
a.lightColorSpan:hover {
  color: #2f80ed;
}
.debatePreviewSides label {
  text-align: center;
  border: 1px solid #60a4e9;
  border-radius: 10px;
  padding: 7px;
}
.debatePreviewAdunit {
  width: 300px;
  height: 250px;
  margin: 0 auto;
  background: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9b9b9b;
  max-width: 100%;
}
.debatePreviewFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e8e8e8;
  padding-top: 10px;
}
.debatePreviewFooter img {
  width: auto;
  height: 15px;
}
.topDebateHeader .arrow svg {
  width: 20px;
  height: 20px;
  color: #d8d8d8;
  margin-left: 10px;
}
.topDebatesTitle svg {
  background: #ff3206;
  background: linear-gradient(180deg, #ff3206 0, #fda103);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ff3206",endColorstr="#fda103",GradientType=0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.topDebatesSection,
.suggestedDebatesSection,
.smartPollSection {
  background: #f6f6f6;
  border-radius: 8px;
  padding: 20px;
}
.topDebatesContent,
.smartPollContent {
  white-space: nowrap;
  width: 100%;
  overflow: auto;
  padding-bottom: 1px;
  min-height: 42px;
  max-height: 460px;
}
.topDebatesContent *,
.smartPollContent * {
  white-space: initial;
}
.topDebate,
.smartPollContent .debatePreviewInner {
  display: inline-block;
  margin-right: 20px;
  background: #ffffff;
  vertical-align: top;
  box-shadow: 0 0px 6px 0px #0000001a;
  border-radius: 8px;
  width: 32%;
  max-width: 334px;
}
.topDebate.relative {
  position: relative;
}
.topDebateSides {
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  border-left-style: solid;
  border-left-width: 5px;
  border-radius: 3px;
  padding: 8px;
  padding-right: 60px;
  overflow-wrap: break-word;
}
.assetsCount {
  list-style: none;
  padding: 0;
  margin: 0;
}
.assetsCount li {
  width: 49%;
  display: inline-block;
  font-size: 13px;
  color: #9b9b9b;
}
.assetsCount.suggDeb li {
  width: 100%;
  display: block;
}
.assetsCount li span {
  font-size: 14px;
  color: #000000;
}
.fa-plus-circle-blue {
  color: #2f80ed;
  background: #ffffff;
  border-radius: 100%;
  border: 1px solid #ffffff;
}
a.publishButton {
  border: 1px solid #2f80ed;
  border-radius: 4px;
  background: rgb(67 165 245 / 10%);
  padding: 4px 12px;
  color: #2f80ed;
  font-weight: 600;
  font-size: 11px;
}

.debates .faArrowAltCircleRight {
  font-size: 18px;
  color: #d8d8d8;
}
.align-item-center {
  align-items: center;
}
.loadingBarWrap {
  width: 100vw;
  height: 5px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999999;
  background: gray;
}
.loadingBar {
  width: 20vw;
  height: 5px;
  background: green;
  position: relative;
  animation: mymove 5s infinite ease-in-out;
}
@keyframes mymove {
  0% {
    left: 0;
  }
  50% {
    left: 80vw;
  }
  100% {
    left: 0;
  }
}

section.closed form.startDebate input,
section.closed form.startDebate select,
section.closed form.startDebate textarea,
section.closed form.startDebate .close {
  pointer-events: none !important;
}
.networkSettingsTabs {
  border: none !important;
}
.networkSettingsTabs .nav-link {
  font-weight: 600;
  font-size: 18px;
  color: #9b9b9b;
  border: none;
  border-radius: 0;
  line-height: 19px;
  padding: 0 25px 0;
  border-right: 2px solid #9b9b9b;
}
.networkSettingsTabs .nav-link.active,
.networkSettingsTabs .nav-link:focus,
.networkSettingsTabs .nav-link:hover {
  border-color: #9b9b9b;
}
.networkSettingsTabs .nav-link:first-child {
  padding: 0 25px 0 0;
}
.networkSettingsTabs .nav-link:last-child {
  padding: 0 0 0 25px;
  border-right: none;
}
.integrationSettingsTab {
  width: 100%;
  max-width: 800px;
}
.integrationSettingsTab label.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #4a4a4a;
  margin-bottom: 5px;
  margin-top: 25px;
}
.integrationSettingsTab h3 {
  font-size: 18px;
  color: #979797;
  margin-bottom: 10px;
}
.integrationSettingsTab p {
  font-size: 13px;
  margin-bottom: 10px;
  color: #4a4a4a;
}
.integrationSettingsTab hr {
  margin: 30px 0;
}
.integrationSettingsTab .form-control {
  background: #f6f6f6;
  border-color: #f6f6f6;
  -webkit-appearance: menulist;
}
.integrationSettingsModal h3 {
  font-weight: 700;
  font-size: 22px;
  color: #000000;
}
.placementNameWrap {
  position: relative;
}
.placementNameWrap a {
  position: absolute;
  bottom: 4px;
  right: 0;
  font-size: 13px;
  padding: 10px 15px;
}
input[type="text"].apiKey {
  background: #ffffff;
}
.apiKeyAnchors a {
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid #d8d8d8;
}
a.disable {
  pointer-events: none;
}
a.enable {
  color: #2f80ed;
}
.enable {
  cursor: pointer;
}
.usernamePlaceholder {
  margin-bottom: 0;
  background: #efefef;
  line-height: 17px;
}
.createUserContent form label {
  font-size: 12px;
  font-weight: 500;
}
.createUserContent form .form-group {
  border-bottom: 0 !important;
  padding-bottom: 0 !important;
}
.createUserContent form #password {
  padding-right: 130px;
}
.generatePassword {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
}
.topDebatesContentWrapper {
  position: relative;
}
.sdLoading {
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  font-size: 18px;
  text-align: right;
  background: #ffffff;
  /* padding: 5px 10px; */
  box-shadow: -20px 0px 50px 20px #fff;
  display: flex;
  align-items: center;
}
.domainsField input {
  padding-right: 75px;
}
.domainsField span {
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
.disabledInput {
  opacity: 0.5 !important;
  pointer-events: none !important;
}
.customSlideToggle {
  transition: all ease-in-out 0.5s;
  max-height: 280px;
  overflow: auto;
}
.customSlideToggle.collapsed {
  max-height: 0;
  /*opacity: 0;*/
  overflow: hidden;
}
.custom-select-wrapper {
  z-index: 1;
}

.custom-select {
  list-style: none;
  background: #fff;
  margin: 0;
  padding: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all ease-in-out 0.3s;
  width: 100%;
  z-index: 1054;
  border: 1px solid #999999;
  border-top: 0;
  margin-top: -5px;
  padding-top: 10px;
}
.custom-select.dropdown-expand {
  max-height: 60vh;
  opacity: 1;
  overflow-y: auto;
  height: auto;
}
.custom-select li {
  padding: 0px 10px;
  cursor: pointer;
}
.custom-select li:hover,
.custom-select li.active {
  background: #f2f2f2;
}
.custom-select li hr {
  display: block;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #d9d9d9;
}
.custom-select li *,
.custom-select-head * {
  display: inline-block;
  vertical-align: middle;
}
.custom-select li img,
.custom-select-head img {
  width: 26px;
  height: 26px;
  border-radius: 0;
  margin-right: 10px;
}
.custom-select li p,
.custom-select-head p {
  line-height: 15px;
  font-size: 14px;
}
.custom-select li p small,
.custom-select-head p small {
  color: #999999;
  font-size: 12px;
  display: block;
}
.custom-select-head {
  background: #ffffff;
  border: none;
  padding: 4px 10px;
  display: block;
  width: 100%;
  min-width: 300px;
  text-align: left;
  border-radius: 5px;
  position: relative;
  z-index: 1055;
  border: 1px solid #999999;
  border-bottom: 0;
  cursor: pointer;
}
.custom-select-head svg {
  position: absolute;
  right: 15px;
  height: 100%;
  top: 0px;
  z-index: -1;
}

.customBtn {
  border-color: #2f80ed;
  color: #2f80ed;
  font-size: 14px;
  background: #ffffff;
  width: auto !important;
  line-height: 18px;
  white-space: nowrap;
}
.customBtn.customBtnBlue {
  background: #2f80ed !important;
  color: #ffffff !important;
}
.customBtn:hover {
  color: #ffffff;
  background: #2f80ed;
}
.deployeDebateTable tr td {
  border: none;
}
.deployeDebateTable tr td a svg {
  margin-bottom: 2px;
}
.debStat {
  background: #f2f2f2;
  border-radius: 10px;
  padding-bottom: 10px;
  transition: all ease-in-out 0.5s;
  width: 100%;
}
.debStat table {
  margin: 0;
}
.tableCommon.debates tr th:first-child,
.debStat table tr th:first-child {
  width: 55%;
  overflow-wrap: anywhere;
}
.deployeDebateTable .title-td {
  width: 47%;
  overflow-wrap: anywhere;
}
.debStat table td {
  padding: 8px 0;
}
.debStat.collapsed {
  background: #fafafa00;
}
.debStat > div > a {
  width: auto;
  min-width: 160px;
  height: 30px;
  text-align: center;
  background: #f2f2f2;
  padding: 2px 15px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.debStat > div {
  padding: 10px 0px;
  transition: all ease-in-out 0.5s;
}
.debStat.collapsed > div {
  padding: 0;
}
.debStat.collapsed .customSlideToggle {
  max-height: 0;
  /*opacity: 0;*/
  overflow: hidden;
}
.customSlideToggle {
  transition: all ease-in-out 0.5s;
  max-height: 280px;
  overflow: auto;
  margin: 0px 20px 0px 30px;
}
#publish-debate-section {
  min-height: 100vh;
}
.depToPagesList {
  max-height: 110px;
  overflow: auto;
}
hr.customHr {
  margin-top: 40px;
  margin-bottom: 30px;
}
.userAvatarWrapper input,
.userCoverImageWrapper input {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}
.profileForm .userAvatarWrapper {
  width: 105px;
  height: 105px;
  border-radius: 100%;
  border: 1px dashed #828282;
  padding: 5px;
  object-fit: cover;
}
.profileForm .userAvatar {
  height: 100%;
  width: 100%;
  border-radius: 100%;
  object-fit: cover;
}
.profileForm .userAvatarPlaceholder {
  background: #f2f2f2;
  display: block;
  height: 100%;
  border-radius: 100%;
}
.profileForm .userCoverImageWrapper {
  /*border: 1px dashed #828282;
  padding: 5px;*/
  /*width: 100%;*/
  /*min-height: 210px;*/
  /*display: flex;
  align-items: center;
  justify-content: center;*/
  overflow: hidden;
}
.profileForm .userCoverImage {
  height: auto;
  object-fit: cover;
  max-height: 200px;
  border: 1px dashed #828282;
  padding: 5px;
  max-width: 100%;
}
.profileForm .userCoverImagePlaceholder {
  background: #f2f2f2;
  height: 150px;
  border: 1px dashed #828282;
  padding: 5px;
  display: block;
}
.profileForm .hasIcon i {
  position: absolute;
  left: calc(50% - 9px);
  top: calc(50% - 9px);
  color: #ffffff;
  /*box-shadow: 0 0 15px 1px #000000;*/
  padding: 0;
}
.embedPlacement .fa-check-circle {
  width: 16px !important;
  height: 16px;
}
.embedPlacement td svg {
  color: #dbdbdb;
}
.embedPlacement td.active svg {
  color: #2aa974;
}
.placementPreviewSection {
  display: flex;
}

.placementPreviewSection {
  box-shadow: 0px 0px 6px 0px #0000001a;
}
.placementPreviewSection.top {
  flex-direction: column;
}
.placementPreviewSection.right {
  flex-direction: row-reverse;
}
.placementPreviewSection.bottom {
  flex-direction: column-reverse;
}
.placementPreviewSection.left {
  flex-direction: row;
}
.placementPreviewSection.top,
.placementPreviewSection.bottom {
  width: 300px;
}
.placementPreviewSection .debateSection {
  width: calc(100% - 400px);
}
.placementPreviewSection.top .debateSection,
.placementPreviewSection.bottom .debateSection {
  width: 100%;
}
.placementPreviewSection .adSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.placementPreviewSection .adSection span {
  font-weight: 700;
  font-size: 36px;
  color: #ffffff;
  font-family: "Open Sans";
  display: block;
  background: #2f80ed;
  display: flex;
  justify-content: center;
  align-items: center;
}
.placementPreviewSection .adSection span {
  width: 400px;
  height: 300px;
}
.placementPreviewSection.top .adSection span,
.placementPreviewSection.bottom .adSection span {
  width: 300px;
  height: 250px;
}
.placementPreviewSection .debatePreviewInner {
  max-width: inherit;
  border-radius: 0;
  box-shadow: none;
}
select.networkId option {
  padding: 10px 8px;
  font-size: 13px;
  font-weight: 400;
  font-family: "Open Sans";
  border-radius: 2px;
}
.AddNetworkToGroupForm,
.AddUserToGroupNetworkForm,
.AddNewNetworkForm,
.AddUserToGroupForm {
  margin: 0 auto;
  width: 350px;
}
.AddNetworkToGroupForm .btn,
.AddUserToGroupNetworkForm .btn,
.AddNewNetworkForm .btn,
.AddUserToGroupForm .btn {
  width: 49%;
}
p.userNameSection {
  font-size: 32px;
  font-weight: 400;
  font-family: "Open Sans";
}
p.userNameSection small {
  color: #9b9b9b;
  font-size: 14px;
  display: block;
}
.groupNetworkUsersTable .toggle-checkbox {
  float: none;
}
.groupNetworkUsersTable .toggle-checkbox:before {
  width: 46px;
  height: 25px;
  top: -6px;
}
.groupNetworkUsersTable .toggle-checkbox:after {
  width: 21px;
  height: 21px;
  top: -4px;
}
.advanceUserSettingsModal .modalContentWrapper {
  max-width: 100%;
}

.updateGroupUserSettingsForm table {
  vertical-align: middle;
}
.updateGroupUserSettingsForm table .form-group {
  padding: 5px 0;
}
.updateGroupUserSettingsForm table tr:last-child td {
  border: none;
}
.currentEditedGroupName input {
  font-size: 14px;
  font-weight: 600;
  width: 400px;
  padding-right: 105px;
}
.currentEditedGroupName .editGroupNameBtns {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 15px;
}
.brandAccountWrap {
  padding: 20px 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.addGroupModal h5 {
  font-family: "Verdana";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #333333;
}
input.toggle-checkbox.disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.7;
}
.sidedFavicon {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  display: block;
  margin-bottom: 17px;
}
form.AddNewNetworkForm input[type="text"] {
  padding: 13px 10px;
}
form.AddNewNetworkForm #subDomainPostFix {
  margin-left: -3px;
  width: auto;
  display: inline-block;
  width: 90px;
}
.searchResultBar {
  width: 250px;
}
.anchorLikeTabs {
  border: none;
}
.anchorLikeTabs a.nav-link {
  border: none;
  font-size: 14px;
  font-weight: 400;
  color: #2f80ed;
  line-height: 15px;
  background: none !important;
}
.anchorLikeTabs a.nav-link.active {
  color: #9b9b9b;
  cursor: default;
}

.current-network-section .dropdown.show .dropdown-menu {
  width: 100%;
  max-height: 250px;
  overflow: auto;
  box-shadow: 0px 0px 10px -5px #000;
}

main.body aside .dropdown button:after {
  color: #9b9b9b;
  position: absolute;
  border-top: 0.5em solid;
  border-right: 0.5em solid transparent;
  border-bottom: 0;
  border-left: 0.5em solid transparent;
  top: calc(50% - 3px);
  right: 15px;
}
.overlappedH3 {
  position: absolute;
  height: 44px;
  display: flex;
  align-items: center;
  z-index: -1;
}
table.networksAdBreakdown th {
  font-size: 13px;
  text-transform: inherit;
}
.btn.side-link,
.btn.side-tag {
  border: 1px solid #e0e0e0;
  background: #ffffff;
  min-width: 38px;
  padding: 8px;
  color: #bdbdbd;
}
.btn.side-link.active,
.btn.side-tag.active {
  background: #bdbdbd;
  color: #ffffff;
}
.btn.side-link:disabled,
.btn.side-tag:disabled {
  background: #bdbdbd;
  color: #ffffff;
  opacity: 1;
}
.sideLink,
.sideTags {
  padding: 5px;
  background: #e8e8e8;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-family: "Open Sans";
  line-height: 16px;
}
.sideLink a {
  color: #0a58ca;
  text-decoration: underline;
}
.sideLink svg,
.sideTags svg {
  width: 13px !important;
  color: #bdbdbd;
  margin-right: 6px;
  margin-left: 7px;
}
.flip {
  transform: scaleX(-1);
}
.add-link-tag-wrapper {
  width: calc(100% - 90px);
}
.add-link-tag-wrapper .sideElementsButtons {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  padding: 4px;
  align-items: center;
}
.add-link-tag-wrapper svg {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  margin: 10px;
  color: #bdbdbd;
}
.add-link-tag-wrapper input {
  border: 1px solid #ced4da !important;
  padding-right: 140px;
}
.sideElementsButtons button {
  width: 62px;
  height: 28px;
}
.nav-tabs .nav-link.disabled {
  color: #bdbdbd;
}
.CreateDebateTabs.nav-tabs .nav-link {
  padding: 18px 38px;
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
}
.CreateDebateTabs.nav-tabs .nav-link:not(.active) {
  background: #f5f5f5;
  border: 1px solid #dee2e6;
  color: #2f80ed;
}
.CreateDebateTabs.sm.nav-tabs .nav-link {
  padding: 10px 16px;
}

.rightColCustomPos {
  position: relative;
  top: -70px;
}
.fa-secondary {
  color: #828282;
}
.customDropdown button {
  width: 100%;
  background: #fff !important;
  color: #4e4e4e !important;
  padding: 7px 14px;
  border-color: #dbdbdb !important;
  text-align: left;
  font-size: 13px;
  font-family: "Open Sans";
  word-break: break-word;
  white-space: break-spaces;
  font-weight: 600 !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.customDropdown button.dropdown-toggle {
  padding-right: 30px;
}
.customDropdown button:after,
.standard-dropdown button:after {
  color: #9b9b9b;
  border-top: 0.5em solid;
  border-right: 0.5em solid transparent;
  border-left: 0.5em solid transparent;
  top: calc(40%);
  position: absolute;
  right: 10px;
}
.customDropdown .dropdown-menu {
  width: 140%;
  max-height: 250px;
  overflow: auto;
}
.customDropdown .dropdown-menu .dropdown-item {
  padding: 5px 10px !important;
  word-break: break-word !important;
  white-space: break-spaces;
  font-weight: 600 !important;
  font-family: "Open Sans";
  font-size: 13px;
}
.embedDomainPageTags {
  white-space: nowrap;
  overflow: hidden;
  max-width: 300px;
}
.embedDomainPageTags:hover {
  overflow-x: auto !important;
}
.embedDomainPageTags .btn:hover {
  box-shadow: none;
  cursor: auto;
}
.deployActions a {
  display: inline-block;
  max-width: 30%;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.smartPollWrapper {
  padding: 15px 18px;
  background: #f5f5f5;
  border-radius: 10px;
  margin: 10px 0 30px 0;
}

.smartPollContent .debatePreviewInner {
  width: 53%;
  max-width: 250px;
  margin-right: 10px;
}
.smartPollContent h6.usernamePlaceholder {
  width: 90px;
  line-height: 13px;
}
.smartPollContent span.usernamePlaceholder {
  width: 65px;
  display: block;
  margin-top: 4px;
  line-height: 9px;
}
.smartPollContent .img-circle.avatar {
  height: 30px;
  width: 30px;
  min-width: 30px;
}
.smartPollContent h6 {
  line-height: 14px;
  font-size: 14px;
}
.smartPollContent .debatePreviewTitle h6 {
  line-height: 18px;
}
.smartPollContent .debatePreviewSides label {
  font-size: 11px !important;
  line-height: 15px !important;
  border-radius: 8px;
  padding: 5px;
}
.smartPollContent .debatePreviewInner > div:not(.debatePreviewAdunit),
.smartPollContent .debatePreviewInner > span {
  padding-right: 12px;
  padding-left: 12px;
}
.smartPollSection .cssload-container {
  position: relative;
  width: auto;
  text-align: center;
}
.smartPollSection div.author .small-dp svg {
  height: 0.8em;
}
.selectPollBtn {
  padding: 5px;
  font-size: 12px;
  margin-left: 0px;
}

table.audience-table {
  border-collapse: separate;
}
table.audience-table tr:first-child {
  position: sticky;
  top: 82px;
  background: white;
  font-weight: bold;
  z-index: 1;
}

.reported-cases-stats label {
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
}
.otherReportsHeader svg {
  width: 25px;
  height: 25px;
  color: #c4c4c4;
  cursor: pointer;
}
.otherReportsFooter .reportedBy {
  font-size: 14px;
  color: #4f4f4f;
}
.reportedBy svg {
  width: 16px;
  height: 16px;
  color: #bdbdbd;
  margin-right: 10px;
}
h6 small,
h5 small {
  color: #828282;
  font-weight: 400;
  display: block;
  font-size: 12px;
}
.report-text {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  font-family: "Open Sans";
  background: #f9f9f9;
  border-radius: 5px;
  padding: 10px 13px;
  margin: 10px 0;
  word-break: break-word;
}
.report-text-wrap label {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
.report-text-wrap .side label {
  font-size: 12px;
  color: #000000 !important;
}
.report-text-wrap .debatePreviewInner {
  max-width: 100%;
  box-shadow: none;
  padding-top: 0;
}
.report-text-wrap .debatePreviewInner > div:not(.debatePreviewAdunit),
.report-text-wrap .debatePreviewInner > span {
  padding: 0;
}
.report-text-wrap h5 {
  font-weight: 700;
}
.reprted-profile {
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
}
.reprted-profile-author-wrapper {
  position: relative;
  min-width: 95px;
  min-height: 90px;
}
.reprted-profile-author {
  position: absolute;
  top: -60px;
}
.reprted-profile-author .img-circle.avatar {
  width: 87px;
  height: 87px;
}
.reprted-profile-author .username {
  color: #2f80ed;
}
.user-profile-info {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  font-family: "Open Sans";
  padding: 10px 13px;
}
.user-profile-info .bolder {
  font-weight: 600;
}
.user-profile-info .bolder b {
  font-weight: 700 !important;
}
.user-profile-cover {
  height: 110px;
}
.user-profile-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
div.reprted-profile-author .small-dp svg {
  position: absolute;
  right: 5px;
  bottom: 5px;
  background: #ffffff;
  border-radius: 100%;
  height: 25px;
}
.radioAsBtns .form-check {
  padding: 0;
  position: relative;
}
.radioAsBtns input[type="radio"] {
  opacity: 1;
  position: absolute;
  right: 40%;
  z-index: -1;
}
.radioAsBtns label {
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 17px !important;
  text-align: center;
  border: 1px solid #e0e0e0;
  color: #2f80ed !important;
  border-radius: 4px;
  padding: 7px 8px;
  margin-right: 6px;
  background: #ffffff;
}
.radioAsBtns input[type="radio"]:checked + label {
  background: #2f80ed !important;
  color: #ffffff !important;
  border-color: #2f80ed !important;
}
.otherReportsWrapper {
  /*display: none;*/
}
.otherReportsWrapper:before {
  opacity: 0;
  content: "1";
  transition: all ease-in-out 0.3s;
}
.otherReportsWrapper.show:before {
  opacity: 1;
  content: "1";
  width: 100vw;
  height: 100vh;
  background: rgb(0 0 0 / 50%);
  z-index: 99999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.otherReports {
  width: 450px;
  height: 100vh;
  overflow: none;
  position: fixed;
  right: -450px;
  top: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999999;
  transition: all ease-in-out 0.3s;
  display: flex;
  flex-direction: column;
}
.otherReports .report-text {
  margin-bottom: 30px;
}
.otherReportsWrapper.show .otherReports {
  right: 0px;
}
.otherReportsBody .debatePreviewInner {
  padding-bottom: 0;
}
.otherReportsBody .report-text {
  margin-bottom: 0;
}
.otherReportsFooter {
  box-shadow: inset 0px 15px 15px -15px rgb(0 0 0 / 25%);
}
.otherReportsScroller {
  overflow: auto;
}
.moderationTabs {
  border: 1px solid #e1e1e1;
  display: flex;
  border-radius: 5px;
}
.moderationTabs span {
  color: #2f80ed;
  padding: 12px 15px;
  font-size: 13px;
  line-height: 16px;
  font-family: "Open Sans";
  cursor: pointer;
}
.moderationTabs span:first-child {
  border-right: 1px solid #e1e1e1;
}
.moderationTabs span.active {
  background: #f7f7f7;
  color: #828282;
  cursor: default;
}
.lockedSuspendStatus {
  font-size: 12px;
  font-family: "Open Sans";
  line-height: 16px;
  padding: 6px 6px 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  color: #4f4f4f;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;
}
.lockedSuspendStatus svg {
  color: #bdbdbd;
  height: 15px;
  margin-left: 10px;
}
.arrowBelowAuthor {
  position: relative;
}
.arrowBelowAuthor:before {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 20px;
  background-repeat: no-repeat;
  left: calc(50% - 1px);
  height: 100%;
  background-position: left bottom;
  bottom: -55px;
}
.arrowBelowAuthor:after {
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  left: calc(50% - 1px);
  background: #e0e0e0;
  margin-top: 5px;
}
.otherReports .arrowBelowAuthor:before {
  margin-top: 5px;
  top: 100%;
}
.otherReports .arrowBelowAuthor:after {
  display: none;
}
span.reportType {
  position: relative;
}
span.reportType:after {
  content: "";
  width: 100%;
  height: 1px;
  background: #4f4f4f;
  position: absolute;
  left: 0;
  bottom: 2px;
  opacity: 0.4;
}
button:disabled {
  opacity: 0.2;
}
.segments .sorting {
  margin-top: 40px;
}
.analytic-stats .card-body,
.advertising-stats .card-body {
  padding: 0.5rem 1rem 1rem 1rem;
}
.custom-dropdown-search {
  top: 0px;
  padding: 8px;
  position: sticky;
  background: #fff;
}
.custom-dropdown-search input {
  font-size: 13px;
}

.form-control:focus {
  box-shadow: none !important;
}
.supportLink {
  font-weight: 400;
  color: #ffff !important;
}
.supportLink:hover {
  text-decoration: underline;
}
@media (min-width: 1320px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1500px;
  }
}

/*@media (min-width: 1025px) {
  ::-webkit-scrollbar {
    height: 8px;
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0 5px #e0e0e0;
    border-radius: 0px;
  }

  ::-webkit-scrollbar-thumb {
    background: #bbbbbb;
    border-radius: 0px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #aaaaaa;
  }
}*/

@media (max-width: 1366px) {
  main.body section {
    padding-left: 20px;
  }
}

@media (max-width: 1200px) {
  .container {
    max-width: 96%;
    width: 100%;
  }
  main.body section h2 {
    font-size: 25px;
  }
}
@media (max-width: 1024px) {
  main.body section {
    padding-left: 0px;
  }
}

.sided-tabs {
  display: flex;
  justify-content: center;
}
.sided-tabs nav {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}
.sided-tabs nav .nav-link {
  color: #333;
  font-size: 12px;
  font-weight: 700;
  border-radius: 0;
  padding: 12px 22px;
  border-right: 1px solid #ddd;
}
.sided-tabs nav .nav-link:last-child {
  border-right: 0 none;
}
.main-category {
  cursor: pointer;
  position: relative;
}
.main-category.active:after {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  position: absolute;
  border-radius: 8px;
  border: 3px solid #2f80ec;
}
.main-category h1 {
  margin: 0;
}
.main-category small {
  opacity: 0.7;
}

.toggle-side {
  opacity: 0.35;
  font-size: 16px;
  cursor: pointer;
  font-weight: 700;
}
.toggle-side.active {
  opacity: 1;
}
.toggle-side + .toggle-checkbox {
  margin: 0 22px;
  cursor: pointer;
  vertical-align: middle;
}
.sided-id.toggle-checkbox:before,
.sided-id.toggle-checkbox:checked:before {
  background: #2f80ec;
}
.sided-id.toggle-checkbox:after {
  box-shadow: none;
}

.toggleSidebarVisibility .menuToggle {
  width: 35px;
  height: 23px;
  transition: all ease-in-out 0.3s;
}

/* Responsive styles */
.toggleSidebarVisibility {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  height: 82px;
  display: flex;
  width: 60px;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 0.3s;
}
.main-left-col .toggleSidebarVisibility {
  position: static;
  background: #3a3a3a;
  width: calc(100% + 17px);
  margin-left: -15px;
  justify-content: left;
  padding-left: 28px;
}
body.menuVisible .main-left-col {
  left: 0;
}
@media (min-width: 768px) {
  .toggleSidebarVisibility {
    display: none;
  }
  .pull-right-lg {
    float: right;
  }
}
@media (max-width: 767px) {
  .blue-button.size-l {
    height: 43px !important;
    padding: 0 20px !important;
  }
  main.collapsed .main-right-col {
    width: 100vw;
    overflow-x: inherit;
  }
  .WLSettings .field-logo {
    height: 50vw;
  }
  .WLSettings .field-favicon,
  .WLSettings .field-emaillogo {
    height: 25vw;
  }
  .WLSettings .buttons {
    position: static;
    text-align: center;
  }
  .apiKeyAnchors {
    width: 100%;
    overflow: auto;
    padding-bottom: 10px;
  }
  main.body section {
    padding-top: 30px;
    margin-bottom: 50px;
  }
  .networkSettingsTabs {
    flex-flow: nowrap;
    overflow: auto;
    padding-bottom: 15px;
  }
  .networkSettingsTabs a {
    text-wrap: nowrap !important;
  }
  .WLSettings h3 {
    margin-top: 10px !important;
  }
  .WLSettings > .col-md-6 {
    padding: 0 !important;
  }
  .general-stats {
    display: block !important;
    background: none !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
  }
  .general-stats > div {
    border: none !important;
    background: #f6f6f6 !important;
    display: inline-block;
    width: 47% !important;
    padding: 20px 10px;
  }
  .general-stats > div:nth-child(2n + 1) {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .section-title {
    margin-bottom: 0 !important;
  }
  .table-holder {
    width: 1100px;
  }
  .table-cell {
    white-space: nowrap;
  }
  .audience-table .table-cell,
  .table-cell a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    padding: 10px !important;
  }
  .table-filters {
    display: block !important;
  }
  .table-pagination {
    justify-content: space-between;
  }
  .table-search {
    margin-bottom: 20px;
    width: 100%;
  }
  .analytic-stats {
    margin: 0 !important;
  }
  .analytic-stats .col-lg-3 {
    width: 47.5%;
    padding: 0px;
  }
  .analytic-stats .col-lg-3:nth-child(2n + 1) {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .advertising-stats > div {
    width: 47.5%;
    padding: 0px;
  }
  .advertising-stats > div:nth-child(2n + 1) {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .advertising-stats .card-body {
    padding: 1rem 2rem !important;
  }
  header .navbar-brand {
    margin-left: 45px;
  }
  .main-left-col {
    position: fixed;
    top: 0px;
    left: -270px;
    background: #ffffff;
    z-index: 99;
    height: 100vh;
    transition: all ease-in-out 0.3s;
  }
  .menuVisible .main-left-col {
    box-shadow: 0 0 10px 6px #000000;
  }
  .menuCollapseToggle {
    display: none;
  }
  body main.body:after {
    content: "";
    position: fixed;
    left: 0;
    top: 0;
    width: 0;
    height: 100vh;
    background: #000000cc;
    z-index: 90;
    transition: all ease-in-out 0.3s;
  }
  body.menuVisible main.body:after {
    width: 100vw;
  }
  body.menuVisible {
    overflow: hidden !important;
  }
  .title-section {
    display: block !important;
    margin-bottom: 30px !important;
  }
  .mobile-block {
    display: block;
  }
  .mobile-block form#search {
    margin-bottom: 20px;
  }
  .table-wrapper {
    width: 100vw;
    overflow: auto;
    max-width: 100%;
  }
  .networksAdBreakdown {
    width: 600px;
  }
  .networksAdBreakdown .w-50 {
    width: auto !important;
  }
  .groupNetworkUsersTable {
    width: 500px;
  }
  table.audience-table tr:first-child {
    position: static;
  }
  .segments .sorting {
    margin-top: 15px;
  }
  .segments .sorting .table-filters-start {
    margin-bottom: 15px;
  }
  .debates.tableCommon {
    width: 670px;
  }
  .topDebate,
  .smartPollContent .debatePreviewInner {
    width: 100%;
    margin-right: 15px;
    max-width: 275px;
  }
  .topDebatesSection,
  .suggestedDebatesSection,
  .smartPollSection {
    padding: 15px 10px;
  }
  .footer-left-col {
    display: block;
    text-align: center;
  }
  .footer-right-col {
    justify-content: center;
    margin-top: 10px;
  }
  table.embedPlacement {
    width: 100%;
    min-width: 580px;
  }
  .currentEditedGroupName input {
    width: 180px;
    padding-right: 8px;
  }
  .currentEditedGroupName .editGroupNameBtns {
    position: static;
    padding: 5px;
  }
  .btn {
    padding: 10px 20px;
  }
  .rightColCustomPos {
    position: static;
  }
  .startDebate .field-backgroundImage {
    height: 30vw;
  }
  .img-field-wrap {
    height: auto;
  }
  .startDebate .img-field-wrap,
  .startDebate .field-backgroundImage,
  .startDebate .img-field-wrap img,
  .startDebate .img-field-placeholder,
  .startDebate .img-field-wrap button {
    position: static !important;
  }
  table.network-users {
    width: 750px;
  }
  body.menuVisible main.collapsed aside {
    /*height: calc(100vh - 82px);*/
  }
  .placementPreviewSection.right,
  .placementPreviewSection.left {
    width: 700px;
  }
  .add-link-tag-wrapper {
    width: 100%;
  }
  .segment-form-body {
    padding: 15px !important;
  }
  .segment-form-condition .select-box,
  .segment-form-condition .input-box {
    margin: 4px 5px 4px 0 !important;
  }
  .modal-close-btn {
    font-size: 24px;
    padding: 0 10px;
  }
  .modal-body {
    margin: 15px auto;
  }
  .AuthorSettings .buttons {
    position: static;
  }
  .common-form .buttons .btn-secondary,
  .common-form .buttons .btn-primary {
    margin-top: 25px;
  }
  .createUserContent form .form-group:first-child {
    padding-top: 0px !important;
  }
  .moderationTabs {
    display: inline-flex;
    margin-top: 15px;
  }
  .reported-cases-body .btn-outline-secondary,
  .reported-cases-body .btn-primary {
    min-width: 190px;
  }
  .authorModal .network-list-row {
    /*width: 500px;*/
    flex-wrap: wrap;
    padding: 15px 0px !important;
  }
  .customDropdown .dropdown-menu {
    max-width: 100%;
  }
  p.userNameSection {
    font-size: 24px;
    margin-bottom: 0;
  }
  .AddNetworkToGroupForm,
  .AddUserToGroupNetworkForm,
  .AddNewNetworkForm,
  .AddUserToGroupForm {
    width: 100% !important;
  }
  .auth-box {
    padding: 18px !important;
    width: 91% !important;
  }
  .auth-box form .text-line {
    white-space: inherit !important;
  }
  footer .footer-right-col ul {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }
  .auth-box form fieldset.code-fields + .end-option {
    margin-bottom: 50px !important;
  }
  .for-stickies {
    padding: 100px 0 90px !important;
  }
  .authContainer header .navbar-brand {
    margin: 20px;
    text-align: center;
    display: block;
  }
  .table-control .table-control-dropdown {
    left: -8px !important;
    max-width: 56vw !important;
    padding: 5px !important;
  }
  .table-control .table-control-dropdown ul li {
    padding: 5px 5px !important;
  }
  .auth-box form fieldset .two-fields {
    display: block !important;
  }
  .auth-box form fieldset .two-fields > div {
    width: 100% !important;
  }
  .profileForm {
    margin-top: 25px;
  }
  .reprted-profile-author-wrapper {
    min-height: 70px;
  }
  .user-profile-info {
    padding: 10px 9px;
  }
  .otherReports {
    width: 100vw;
    right: -100vw;
    display: block;
    overflow: auto;
  }
  .sided-modal-body {
    padding: 15px !important;
  }
  .reprted-profile-author {
    top: -40px;
  }
  .reprted-profile-author .img-circle.avatar {
    width: 60px;
    height: 60px;
  }
  .user-profile-cover {
    height: 90px;
  }
  .AuthorSettings .form-group {
    padding: 25px 10px !important;
  }
  .common-form:not(.AuthorSettings, .DeployDebateForm) label:not(.sub-label) {
    font-size: 12px;
  }
  .network-list-name {
    flex: 1 0 75%;
  }
  .network-list-count {
    flex: 1 0 25%;
  }
  .network-list-buttons {
    text-align: left !important;
    margin: 15px 0 0 20px;
  }
  .network-list-buttons > * {
    margin-bottom: 10px;
  }
  .network-list-id {
    overflow-wrap: anywhere;
  }
  div.author .copy-wrap {
    overflow-wrap: anywhere;
  }
  div.reprted-profile-author .small-dp svg {
    left: 42px;
    height: 18px;
  }
}
.infinite-scroll-component__outerdiv .infinite-scroll-component .infinite-loading {
  padding: 5px;
}
.poll-box {
    color: #333;
    font-size: 15px;
    overflow: hidden;
    padding: 8px 12px;
    position: relative;
    border-radius: 5px;
    background: transparent;
    justify-content: space-between;
    border: 0;
    border-left: 5px solid transparent;
    display: flex;
    line-height: 1.3;
    text-align: center;
    margin-bottom: 5px;
    align-items: center;
}
.poll-box .full-side-bar {
  position: absolute;
  opacity: .08;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
}
.poll-box .overlay-box {
  opacity: .1;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
}
.poll-box .poll-text {
  position: relative;
  margin-right: 55px;
  text-align: left;
  z-index: 3;
}
.poll-percent {
  top: 50%;
  padding: 0;
  z-index: 3;
  right: 16px;
  font-size: 13px;
  text-align: right;
  position: absolute;
  transform: translateY(-50%);
}
.react-datepicker__month.react-datepicker__monthPicker .react-datepicker__month-wrapper{
  padding: 3px;
  font-size: 12px;
}
.react-datepicker__month-text--keyboard-selected:not([aria-disabled="true"]):hover {
  color: white;
}
.react-datepicker__month .react-datepicker__month-text, .react-datepicker__month .react-datepicker__quarter-text {
  line-height: 20px
}
.view-poll-box {
  width: 350px;
  margin-right: 0px;
}
.view-poll-box.last-step {
  width: 700px;
}
.view-poll-box.last-step .debatePreviewSection1 {
  width: 350px;
}
.view-poll-box.last-step .react-flow__handle-bottom {
  left: 25%;
}
.view-poll-box .debatePreviewInner {
  max-width: unset;
}
.user-option-selected-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-option-header {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}
.remove-button {
  font-size: 13px;
  font-weight: 400;
  line-height: 16.34px;
  color: #2F80ED;
  cursor: pointer;
}
.option-container {
  border: 1px solid #E0E0E0;
  min-height: 40px;
  border-radius: 4px;
  color: #4A4A4A;
  padding: 8px;
}
.step-number {
  width: 100%;
  height: 20px;
  margin-right: 0px;
}
.add-step-branch-group {
  display: flex;
  gap: 1px;
  margin-top: 8px;
  justify-content: center;
}
.add-branch-image {
  margin: 0px;
  height: 12px;
  width: 12px;
  font-size: 18px;
  line-height: 1;
}
.add-step-container {
  height: 100px;
  width: 300px;
}
.add-step-button-container {
  width: 300px;
  height: 20px;
  margin-right: 0px;
}
.add-step-button {
  border-radius: 20px;
  padding: 5px 5px;
  margin: 0px;
  height: 40px;
  width: 40px;
  font-size: 18px;
  line-height: 1;
}
.react-flow__handle {
  opacity: 0;
}
.debatePreviewVotes {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));
  grid-auto-rows: minmax(100px, auto);
  align-items: center;
  margin-top: 10px;
}

.vote-container {
  position: relative;
  height: 138px;
  min-width: 138px;
}

.vote-image-container {
  overflow: hidden;
}

.vote-image-container img {
  width: 100%;
  height: 138px;
  border-radius: 6px;
  object-fit: cover;
}

.vote-overlay {
  position: absolute;
  height: 23px;
  z-index: 1;
  opacity: 0.7;
  bottom: 10px;
  background: rgba(255, 255, 255, 0.7);
  width: 90%;
  display: flex;
  left: 5%;
  border-radius: 100px;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
}

.vote-text {
  max-width: 65%;
  font-size: 11px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 30px;
}

.vote-percentage {
  width: 35%;
  font-weight: 700;
  font-size: 11px;
  text-align: right;
  margin-right: 5px;
}

.check-icon {
  border-radius: 50%;
  bottom: 10px;
  height: 23px;
  width: 23px;
  left: 7px;
  position: absolute;
  opacity: 1;
  background: rgba(255, 255, 255, 0.7);
  text-align: center;
  color: #E0E0E0;
}
.debate-image-web {
  display: block; /* Default state */
}

@media (max-width: 768px) {
  .debate-image-web {
    display: none;
  }
}
.debate-image-mobile {
  display: none; /* Default for non-mobile screens */
}

@media (max-width: 768px) {
  .debate-image-mobile {
    display: flex; /* Show as flex on mobile */
    gap: 5px;
    background-color: rgb(245, 245, 245);
    padding-bottom: 10px;
    padding-right: 10px;
    border-radius: 4px;
  }
}
.network-admin-toggle {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.network-admin-toggle div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.network-admin-toggle div .form-check-label {
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,QAAQ;AACV;AACA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;eACa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE;AACF;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,eAAe;;AAEf;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kDAAkD;EAClD,qDAAqD;EACrD,sDAAsD;EACtD,0DAA0D;EAC1D,uDAAuD;EACvD,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,kDAAkD;EAClD,qDAAqD;EACrD,sDAAsD;EACtD,0DAA0D;EAC1D,uDAAuD;AACzD;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,sDAAsD;EACtD,0DAA0D;EAC1D,uDAAuD;AACzD;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AA8BA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AA8BA;EACE;IACE,0BAA0B;EAC5B;AACF;;AA0BA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE;oBACkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,WAAW;AACb;AACA;;;;;EAKE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;;UAEQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uDAAuD;EACvD,gHAAgH;EAChH,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE;IACE,OAAO;EACT;EACA;IACE,UAAU;EACZ;EACA;IACE,OAAO;EACT;AACF;;AAEA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,MAAM;EACN,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;;EAEE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;gBACc;EACd,eAAe;EACf,qBAAqB;EACrB;;2BAEyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;;;EAIE,cAAc;EACd,YAAY;AACd;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yDAAsX;EACtX,WAAW;EACX,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;IACf,OAAO;IACP,MAAM;IACN,QAAQ;IACR,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,gCAAgC;EAClC;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;;IAEE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;;;;;IAKE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,8BAA8B;EAChC;EACA;;IAEE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;;;;IAIE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;IACd,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,MAAM;EACN,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa,EAAE,mCAAmC;AACpD;;AAEA;EACE;IACE,aAAa,EAAE,2BAA2B;IAC1C,QAAQ;IACR,oCAAoC;IACpC,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700\");\n\nbody {\n  color: #4a4a4a;\n  overflow-x: hidden;\n}\nb,\nstrong {\n  font-weight: 600 !important;\n}\nh2 small {\n  font-size: 14px;\n  display: block;\n  line-height: 24px;\n  color: #979797;\n}\ntextarea[readonly] {\n  font-size: 12px;\n  font-family: \"Open Sans\";\n  color: #828282;\n}\n.square input[type=\"radio\"] {\n  border-radius: 4px;\n  border: 2px solid #ffffff;\n  box-shadow: 0px 0px 0px 1px #c4c4c4;\n  margin-top: 5px;\n}\n.square input[type=\"radio\"]:checked {\n  background-color: #4a4a4a;\n  background-image: none;\n}\n.square .form-check-label {\n  font-size: 13px;\n  color: #9b9b9b;\n}\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl {\n  max-width: 1260px;\n}\n.hiddenElement {\n  opacity: 0 !important;\n  position: fixed !important;\n  left: -500px !important;\n  top: -500px !important;\n  z-index: -99999 !important;\n  width: 1px !important;\n  height: 1px !important;\n  overflow-x: hidden !important;\n}\n.txtCenter {\n  text-align: center;\n}\n.txtLeft {\n  text-align: left !important;\n}\n.customLabel {\n  font-size: 13px;\n}\n.customAnchor {\n  color: #2f80ed !important;\n  font-size: 14px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.customAnchor:last-child {\n  border: none;\n}\n.customAnchor.red {\n  color: #f55b4f !important;\n}\n.customAnchor.light {\n  color: #bdbdbd !important;\n}\n.txtRight {\n  text-align: right;\n}\n.sucessMsg,\n.success {\n  position: fixed;\n  left: 20px;\n  bottom: 20px;\n  padding: 20px;\n  background: #40a540;\n  color: #fff;\n  border-radius: 5px;\n  z-index: 9999;\n  width: auto;\n}\n.fail {\n  position: fixed;\n  left: 20px;\n  bottom: 20px;\n  padding: 20px;\n  background: #f55b4f;\n  color: #fff;\n  border-radius: 5px;\n  z-index: 9999;\n}\na {\n  text-decoration: none;\n  display: block;\n  cursor: pointer;\n  color: inherit;\n}\n.h5,\nh5 {\n  color: #4a4a4a;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 19px;\n}\n.h5 a:hover,\nh5 a:hover {\n  color: #4a4a4a;\n}\n.h6,\nh6 {\n  color: #333333;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 19px;\n  word-wrap: break-word;\n}\n.validation-error {\n  font-size: 13px;\n  color: #f00;\n  margin: 10px 0;\n}\nlabel {\n  font-size: 18px;\n}\ninput {\n  max-width: 100%;\n}\ninput[type=\"text\"] {\n  background: #fcfcfc;\n  border: 1px solid #ced4da;\n  border-radius: 3px;\n  padding: 8px;\n}\ninput[type=\"checkbox\"] {\n  margin: 10px 18px;\n  padding: 7px;\n}\n.fieldInfo {\n  color: #9b9b9b;\n  font-size: 13px;\n  font-weight: 400;\n}\n.loading > *:not(.sucessMsg),\n.formSubmitting > *:not(.sucessMsg) {\n  opacity: 0.5;\n}\nselect.selectfield {\n  border: 1px solid #e0e0e0;\n  background: #ffffff;\n  padding: 8px 15px 8px 10px;\n  border-radius: 5px;\n  width: 240px;\n  margin: 0 15px 0 0;\n  appearance: auto;\n  font-size: 13px;\n  font-family: \"Open Sans\";\n}\n.btn {\n  padding: 10px 30px;\n  white-space: nowrap;\n}\n.btn:hover {\n  box-shadow: 0 0 5px 0px #959595;\n}\n.btn-secondary {\n  background-color: #828282;\n  border-color: #828282;\n}\n.btn-secondary-light {\n  background: #f2f2f2;\n}\n.btn.btn-md {\n  font-size: 12px;\n}\n.btn.orange {\n  background: #f2994a !important;\n  border-color: #f2994a;\n}\n.modal-header {\n  background: #f9f9f9;\n  border: 0px;\n  padding: 20px 30px;\n}\n.modal-body {\n  max-width: 550px;\n  margin: 50px auto;\n  width: 100%;\n}\n.modal-title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 27px;\n  font-family: \"Open Sans\";\n}\n.table.tableCommon > :not(:first-child) {\n  border: inherit;\n}\nheader,\nfooter {\n  background: #000000;\n}\nheader {\n  position: sticky;\n  z-index: 10;\n  left: 0px;\n  top: 0px;\n}\nheader .navbar-brand {\n  margin: 22px 0;\n  height: 38px;\n  display: inline-block;\n  padding: 0;\n}\nheader .navbar-brand > img {\n  max-height: 100%;\n  margin: 0;\n  filter: invert(1);\n}\nheader .header-right-col {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  position: relative;\n  z-index: 2;\n}\nheader .avatarSection .user-avatar {\n  position: relative;\n  display: block;\n}\nheader .avatarSection .user-avatar svg {\n  position: absolute;\n  right: 1px;\n  bottom: 1px;\n  background: #ffffff;\n  border-radius: 100%;\n  height: 13px;\n  width: 13px;\n}\nheader .avatarSection .user-handle {\n  font-size: 14px;\n  color: #9b9b9b;\n  display: block;\n}\nheader .userDropDown {\n  position: absolute;\n  right: -5px;\n  background: #fff;\n  top: 6px;\n  padding: 20px;\n  border-radius: 7px;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n}\nheader .userDropDown a {\n  color: #2f80ed;\n}\nheader .userDropDown button {\n  width: 250px;\n}\n.fa-question-circle {\n  font-size: 20px !important;\n  margin: 20px;\n  color: #4a4a4a;\n}\nheader .user-avatar img,\nheader .user-avatar svg {\n  width: 45px;\n  height: 45px;\n  font-size: 45px;\n}\nform#search {\n  position: relative;\n  min-width: 300px;\n}\nform#search input[type=\"text\"] {\n  height: 40px;\n  width: 100%;\n  padding-right: 40px;\n  border: none;\n  background: #f6f6f6;\n  font-size: 13px;\n  font-family: \"Open Sans\";\n}\nform#search button {\n  background: none;\n  border: none;\n  position: absolute;\n  color: #9b9b9b;\n  top: 2px;\n  right: 6px;\n}\nform#search button i {\n  font-size: 21px;\n}\nform#search.searchForm1 {\n  min-width: 100px;\n  width: 380px;\n  max-width: 100%;\n}\n.display-inline {\n  display: inline;\n}\n\n#role-filter {\n  background: #fcfcfc;\n  border: 1px solid #ced4da;\n  border-radius: 3px;\n  padding: 7px;\n}\nmain.body {\n  min-height: calc(100vh - 130px);\n}\n.main-left-col {\n  border-right: 2px solid #f1f1f1;\n  padding: 0;\n}\n.main-left-col aside {\n  position: sticky;\n  top: 82px;\n  left: 0;\n  z-index: 1;\n}\n.main-right-col {\n  /*min-height: 100vh;*/\n  background: #ffffff;\n}\nmain.body aside {\n  height: calc(100vh - 82px);\n  overflow: auto;\n}\nmain.body aside h2 {\n  font-size: 15px;\n  line-height: 19px;\n  color: #4a4a4a;\n  margin: 0;\n}\n\nmain.body aside .dropdown button.dropdown-toggle,\n.standard-dropdown button.dropdown-toggle {\n  width: 100%;\n  background: none !important;\n  text-align: left;\n  box-shadow: none !important;\n  color: #000 !important;\n  font-weight: 600 !important;\n  font-size: 13px;\n  padding: 10px 40px 10px 12px !important;\n  border-radius: 5px;\n  border: 1px solid #e0e0e0 !important;\n  word-break: break-word !important;\n  white-space: break-spaces;\n}\n\n.standard-dropdown .dropdown-menu {\n  overflow: auto;\n  min-width: 100%;\n  padding-top: 0px;\n  max-height: 300px;\n}\n.standard-dropdown .dropdown-menu .dropdown-item {\n  font-size: 13px;\n}\n\n.menuToggle {\n  cursor: pointer;\n}\n\nmain.body aside nav ul li a.active i,\nmain.body aside nav ul li a.active svg path {\n  color: #2f80ed;\n  fill: #2f80ed;\n  stroke: #2f80ed;\n}\nmain.body aside nav ul li i,\nmain.body aside nav ul li svg {\n  font-size: 24px;\n  vertical-align: middle;\n  color: #979797;\n  width: 30px !important;\n  text-align: center;\n}\n\nmain.body section {\n  padding-top: 20px;\n  padding-left: 18px;\n  margin-bottom: 100px;\n}\nmain.body section h2 {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  color: #4a4a4a;\n  font-family: Open Sans;\n}\nmain.body section h3 {\n  font-size: 16px;\n  color: #333333;\n  font-weight: 600;\n  font-family: \"Open Sans\";\n}\nmain.body section h3.lightColor,\n.modal-content h3.lightColor {\n  font-size: 18px;\n  color: #979797;\n  font-family: \"open sans\";\n  font-weight: 600;\n}\nmain.body section .title-section {\n  margin-bottom: 40px;\n}\nfooter .footer-right-col {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n}\nfooter .footer-left-col span {\n  color: #ffffff;\n  font-size: 16px;\n  line-height: 20px;\n}\nfooter .footer-right-col ul {\n  list-style: none;\n  font-size: 14px;\n  margin: 0 !important;\n}\nfooter .footer-right-col ul li {\n  display: inline-block;\n  color: #ffffff;\n}\nfooter .footer-right-col ul li a {\n  color: #ffffff;\n  text-decoration: none;\n}\nfooter .footer-right-col ul li a:hover {\n  color: #b9b9b9;\n}\n\n/* User listing */\ntable.tableCommon th {\n  font-size: 11px;\n  line-height: 13px;\n  color: #9b9b9b;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 5px 5px;\n  font-weight: 600;\n  vertical-align: middle;\n  font-family: \"Open Sans\";\n}\ndiv.author {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\ndiv.author .copy-wrap {\n  margin-left: 10px;\n  line-height: 1;\n}\ndiv.author .copy-wrap .authorhandle {\n  font-size: 13px;\n}\n.img-circle.avatar {\n  /*height: 44px;\n  width: 44px;*/\n  height: 38px;\n  width: 38px;\n  min-width: 38px;\n  border: 2px solid #9b9b9b;\n  background-color: #ffffff;\n  object-fit: cover;\n  display: block;\n  border-radius: 50%;\n  /*padding: 2px;*/\n  padding: 0px;\n}\n.img-circle.avatar.avatar-lg {\n  width: 45px;\n  height: 45px;\n}\ndiv.author .small-dp,\ndiv.reprted-profile-author .small-dp {\n  position: relative;\n}\ndiv.author .small-dp svg {\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  background: #ffffff;\n  border-radius: 100%;\n}\ndiv.author .user-color-green {\n  color: #2aa974;\n}\ndiv.author .user-color-blue {\n  color: #2f80ed;\n}\ndiv.author .user-color-green .img-circle.avatar {\n  border-color: #2aa974;\n}\ndiv.author .user-color-blue .img-circle.avatar {\n  border-color: #2f80ed;\n}\na.authorname h6 {\n  margin: 0;\n  padding: 0;\n}\na.authorhandle {\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 15px;\n  color: #9b9b9b;\n}\n\ndiv.author.medium .img-circle.avatar {\n  height: 52px;\n  width: 52px;\n}\ndiv.author.medium a.authorname h6 {\n  font-size: 24px;\n  line-height: 32px;\n}\ndiv.author.medium a.authorhandle {\n  font-size: 14px;\n  line-height: 20px;\n}\ntable.tableCommon th svg {\n  vertical-align: initial;\n}\ntable.tableCommon th.ASC svg {\n  transform: rotate(180deg);\n}\ntable.tableCommon td .svg {\n  width: 16px !important;\n  height: 16px !important;\n}\ntable.tableCommon td {\n  font-size: 12px;\n  padding: 15px 5px;\n}\ntable.tableCommon th:not(:first-child),\ntable.tableCommon td:not(:first-child) {\n  text-align: center;\n  vertical-align: middle;\n}\ntable.network-users th:nth-child(2),\ntable.network-users td:nth-child(2) {\n  text-align: left;\n  padding-left: 10px;\n}\ntable.tableCommon td strong {\n  font-size: 14px;\n  display: block;\n}\n.verified-green,\n.usercheck-green {\n  color: #2aa974;\n}\n.verified-blue,\n.usercheck-blue {\n  color: #2f80ed;\n}\n.verified-false,\n.usercheck-false {\n  color: #dbdbdb;\n}\n.AuthorSettings {\n  margin-top: 50px;\n}\n.AuthorSettings .form-group {\n  padding: 25px 15px !important;\n  margin: 0;\n  border-bottom: 1px solid #f2f2f2 !important;\n}\n\n.AuthorSettings .addNetworkField {\n  position: relative;\n}\n.AuthorSettings i {\n  position: absolute;\n  right: 0;\n  padding: 8px;\n  font-size: 18px;\n  color: #9b9b9b;\n}\n.AuthorSettings .buttons {\n  position: absolute;\n  right: 22px;\n  top: -156px;\n}\n.toggle-checkbox {\n  float: right;\n  position: relative;\n}\n.toggle-checkbox:before {\n  background: #e9e9eb;\n  content: \"\";\n  width: 50px;\n  height: 30px;\n  display: block;\n  border-radius: 20px;\n  position: absolute;\n  right: -20px;\n  top: -10px;\n  transition: all 0.1s ease-in-out;\n}\n.toggle-checkbox:after {\n  content: \"\";\n  display: block;\n  width: 26px;\n  height: 26px;\n  background: #ffffff;\n  position: absolute;\n  border-radius: 20px;\n  right: 2px;\n  top: -8px;\n  transition: all 0.1s ease-in-out;\n  box-shadow: 5px 0px 10px 0px #c3c3c3;\n}\n.toggle-checkbox:checked:before {\n  background: #34c759;\n}\n.toggle-checkbox:checked:after {\n  right: -18px;\n  box-shadow: none;\n}\n\n.toggle-checkbox.small:before {\n  width: 40px;\n  height: 24px;\n  top: -6px;\n  right: -14px;\n}\n.toggle-checkbox.small:after {\n  width: 20px;\n  height: 20px;\n  right: 4px;\n  top: -4px;\n}\n.toggle-checkbox.small:checked:after {\n  right: -12px;\n}\n.AuthorSettings .buttons {\n  text-align: center;\n}\n.common-form .buttons .btn-secondary {\n  background: #ffffff;\n  color: #828282;\n  border-color: #bdbdbd;\n  margin: 50px 8px 0;\n}\n.common-form .buttons .btn-primary {\n  margin: 50px 8px 0;\n}\n.common-form .buttons .btn {\n  font-size: 16px;\n  line-height: 22px;\n  border-radius: 5px;\n  font-weight: 400;\n}\n\n.btn.btn-primary {\n  background: #2f80ed;\n}\n.btn-outline-primary {\n  border-color: #2f80ed;\n  color: #2f80ed;\n}\n.btn.btn-primary.light {\n  background: #60a4e9;\n  border-color: #60a4e9;\n}\n.btn.btn-secondary.light {\n  background: #f2f2f2;\n  border-color: #f2f2f2;\n  color: #4a4a4a;\n}\n.btn.btn-sm {\n  padding: 0.3rem 0.5rem;\n  font-size: 12px;\n  line-height: 18px;\n  font-family: \"Open Sans\";\n}\n\n.network-favicon {\n  width: 30px;\n}\nspan.networkname {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n}\n/*.debDeployModal .modal-body , .removeDebModal .modal-body{\n  width: 550px;\n    max-width: 100%;\n    margin: 0 auto;\n}*/\n.DeployDebateForm .form-group {\n  padding: 10px 0;\n}\n.DeployDebateTabs.nav-tabs {\n  border: none;\n}\n.DeployDebateTabs.nav-tabs .nav-link {\n  border: none;\n  border-radius: 5px;\n  padding: 10px 30px;\n  background: #f6f6f6;\n  color: #828282;\n}\n.DeployDebateTabs.nav-tabs .nav-link.active {\n  color: #fff;\n  background: #828282;\n}\n.DeployDebateTabs.nav-tabs .nav-link:first-child {\n  margin-right: 10px;\n}\n.debate-image {\n  margin-left: 15px;\n}\n.debate-image img {\n  background: #d8d8d8;\n  width: 100px !important;\n  height: 65px !important;\n  object-fit: cover;\n}\n.debateDefaultImg {\n  background: #d8d8d8;\n  width: 100px !important;\n  height: 65px !important;\n  object-fit: cover;\n}\nh6.debatename {\n  font-weight: 400;\n  font-size: 13px;\n  text-align: left;\n  margin: 0;\n}\ni.debStatus {\n  width: 13px;\n  height: 13px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #f2f2f2;\n}\ni.debStatus.active {\n  background: #27ae60;\n}\n.listItem7 {\n  display: inline-block;\n  padding: 0 10px;\n  border-right: 1px solid #ccc;\n  font-size: 11px;\n  line-height: 14px;\n}\n.listItem7:nth-of-type(1) {\n  padding-left: 0;\n}\n.listItem7:last-child {\n  border-right: 0;\n  padding-right: 0;\n}\n\n.card.widget-flat {\n  background: #f6f6f6;\n  border: 1px solid #f6f6f6;\n  border-radius: 8px;\n}\nh5.analyTitle1 {\n  font-size: 12px;\n  font-weight: 700;\n  height: 40px;\n  text-transform: uppercase;\n  margin: 0 0 5px 0;\n  display: flex;\n  align-items: center;\n}\nh5.analyTitle1 > i.fa,\nh5.analyTitle1 > svg {\n  color: #9b9b9b;\n  font-size: 20px;\n  margin: 0 8px 0 0;\n}\nh3.analyNum1 {\n  font-size: 38px;\n  font-weight: 700;\n  text-align: center;\n  color: #2f80ed;\n  text-transform: uppercase;\n  margin: 0;\n}\n.analyNumInf {\n  text-align: center;\n  color: #979797;\n  font-size: 14px;\n  height: 20px;\n}\n.analyTabInf {\n  font-size: 11px;\n  color: #9b9b9b;\n  margin: 0;\n}\n.analyTabInf i.fa-caret-up,\n.analyTabInf i.fa-caret-down {\n  font-size: 18px;\n  vertical-align: bottom;\n  margin: 0 0 0 3px;\n}\n.analyTabInf i.fa-caret-up {\n  color: #2aa974;\n}\n.analyTabInf i.fa-caret-down {\n  color: #ce0b47;\n}\n.dropdown9 .dropdown-menu {\n  padding: 0.3rem 0;\n}\n.dropdown9 .dropdown-item {\n  font-size: 13px;\n  padding: 0.5rem 1rem;\n}\n\n/* Loader css */\n\n.loader-top {\n  background-color: #fff;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1111;\n}\n\n.loader-top.absolute {\n  z-index: 5;\n  position: absolute;\n}\n.loader-top.transparent {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.cssload-container {\n  display: block;\n  width: 120px;\n  left: 50%;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n.cssload-container.loadMore {\n  position: static;\n  text-align: center;\n  margin: 0 auto;\n  transform: none;\n}\n\n.cssload-container img {\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n\n.cssload-loading {\n  margin-left: 10px;\n}\n\n.cssload-loading i {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #333;\n}\n\n.cssload-loading i:first-child {\n  opacity: 0;\n  animation: cssload-loading-ani2 1s linear infinite;\n  -o-animation: cssload-loading-ani2 1s linear infinite;\n  -ms-animation: cssload-loading-ani2 1s linear infinite;\n  -webkit-animation: cssload-loading-ani2 1s linear infinite;\n  -moz-animation: cssload-loading-ani2 1s linear infinite;\n  transform: translate(-19px);\n  -o-transform: translate(-19px);\n  -ms-transform: translate(-19px);\n  -webkit-transform: translate(-19px);\n  -moz-transform: translate(-19px);\n}\n\n.cssload-loading i:nth-child(2),\n.cssload-loading i:nth-child(3) {\n  animation: cssload-loading-ani3 1s linear infinite;\n  -o-animation: cssload-loading-ani3 1s linear infinite;\n  -ms-animation: cssload-loading-ani3 1s linear infinite;\n  -webkit-animation: cssload-loading-ani3 1s linear infinite;\n  -moz-animation: cssload-loading-ani3 1s linear infinite;\n}\n\n.cssload-loading i:last-child {\n  animation: cssload-loading-ani1 1s linear infinite;\n  -o-animation: cssload-loading-ani1 1s linear infinite;\n  -ms-animation: cssload-loading-ani1 1s linear infinite;\n  -webkit-animation: cssload-loading-ani1 1s linear infinite;\n  -moz-animation: cssload-loading-ani1 1s linear infinite;\n}\n\n@keyframes cssload-loading-ani1 {\n  100% {\n    transform: translate(39px);\n    opacity: 0;\n  }\n}\n\n@-o-keyframes cssload-loading-ani1 {\n  100% {\n    -o-transform: translate(39px);\n    opacity: 0;\n  }\n}\n\n@-ms-keyframes cssload-loading-ani1 {\n  100% {\n    -ms-transform: translate(39px);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes cssload-loading-ani1 {\n  100% {\n    -webkit-transform: translate(39px);\n    opacity: 0;\n  }\n}\n\n@-moz-keyframes cssload-loading-ani1 {\n  100% {\n    -moz-transform: translate(39px);\n    opacity: 0;\n  }\n}\n\n@keyframes cssload-loading-ani2 {\n  100% {\n    transform: translate(19px);\n    opacity: 1;\n  }\n}\n\n@-o-keyframes cssload-loading-ani2 {\n  100% {\n    -o-transform: translate(19px);\n    opacity: 1;\n  }\n}\n\n@-ms-keyframes cssload-loading-ani2 {\n  100% {\n    -ms-transform: translate(19px);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes cssload-loading-ani2 {\n  100% {\n    -webkit-transform: translate(19px);\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes cssload-loading-ani2 {\n  100% {\n    -moz-transform: translate(19px);\n    opacity: 1;\n  }\n}\n\n@keyframes cssload-loading-ani3 {\n  100% {\n    transform: translate(19px);\n  }\n}\n\n@-o-keyframes cssload-loading-ani3 {\n  100% {\n    -o-transform: translate(19px);\n  }\n}\n\n@-ms-keyframes cssload-loading-ani3 {\n  100% {\n    -ms-transform: translate(19px);\n  }\n}\n\n@-webkit-keyframes cssload-loading-ani3 {\n  100% {\n    -webkit-transform: translate(19px);\n  }\n}\n\n@-moz-keyframes cssload-loading-ani3 {\n  100% {\n    -moz-transform: translate(19px);\n  }\n}\n\n.pagination {\n  justify-content: center;\n}\n.pagination li {\n  border: 1px solid #2f80ed;\n  margin: 0 3px;\n  border-radius: 2px;\n}\n.pagination li a {\n  padding: 0 5px;\n}\n.pagination li.active {\n  background: #2f80ed;\n  color: #fff;\n}\nli.previous,\nli.next {\n  font-size: 25px;\n  line-height: 18px;\n}\nli.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.authContainer {\n  /*height: 100vh;\n  overflow: hidden;*/\n}\n.authTopFav {\n  width: 86px;\n  height: 86px;\n  margin-bottom: 20px;\n}\n.authTopLogo {\n  height: 40px;\n  width: auto;\n  max-width: 150px;\n  display: block;\n  margin: 0 auto;\n}\n.login-div {\n  display: flex;\n  justify-content: center;\n  min-height: calc(100vh - 30px);\n  align-items: center;\n  margin: 15px auto;\n  opacity: 0;\n  transition: opacity ease-in-out 0.5s;\n}\n.loaded-true {\n  opacity: 1;\n}\n.login-div .logo-section {\n  margin-bottom: 40px;\n}\n.login-div .logo-section h1 {\n  font-weight: 800;\n  letter-spacing: -2px;\n  font-family: sans-serif;\n  font-size: 48px;\n  color: #000000;\n}\n.login-container {\n  border: 1px solid #d5d5d5;\n  padding: 50px 20px;\n  border-radius: 10px;\n  background: #f9f9f9;\n  width: 630px;\n  text-align: center;\n}\n.login-div fieldset {\n  position: relative;\n  max-width: 360px;\n  width: 100%;\n  display: block;\n  margin: 0 auto 20px;\n}\n.login-div i {\n  position: absolute;\n  left: 15px;\n  top: 17px;\n  color: #dbdbdb;\n}\n.login-div input {\n  padding: 12px 12px 12px 35px;\n  font-size: 16px;\n  color: #4a4a4a !important;\n  border-radius: 5px;\n}\n.login-div button {\n  max-width: 333px;\n  width: 100%;\n  font-weight: 500;\n  border-radius: 5px;\n}\n\n.inline-content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.inline-content.top {\n  align-items: start;\n}\n.inline-content.middle {\n  align-items: center;\n}\n.inline-content.bottom {\n  align-items: end;\n}\n.WLSettings .buttons {\n  position: absolute;\n  top: -85px;\n  right: 0;\n}\n.addNetwork .buttons {\n  top: -90px;\n}\n.common-form:not(.AuthorSettings, .DeployDebateForm) label:not(.sub-label) {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: #4a4a4a;\n  margin-bottom: 5px;\n  display: block;\n  font-family: \"Open Sans\";\n}\n.common-form .form-group {\n  border: none;\n  padding-top: 5px;\n  padding-bottom: 15px;\n  margin: 0;\n}\n\n.sided-form .form-control {\n  padding: 8px;\n  background: #ffffff;\n  font-size: 13px;\n  line-height: 19px;\n  font-family: \"Open sans\";\n}\n\n.WLSettings .form-control,\n.profileForm .form-control {\n  font-size: 14px;\n  line-height: 22px;\n  padding: 13px;\n  background: #fcfcfc;\n}\n.WLSettings .form-group input[type=\"checkbox\"] {\n  float: none;\n}\n\n.WLSettings .buttons {\n  text-align: right;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n}\n\n.WLSettings .buttons .btn-primary {\n  margin: 10px 0 0 0;\n}\n\n.WLSettings .buttons .btn-secondary {\n  margin: 10px 8px 0 0;\n}\n\n.common-form .form-group select {\n  padding: 8px 10px;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  color: #4e4e4e;\n  width: 100%;\n  appearance: auto;\n  -webkit-appearance: auto;\n}\n.WLSettings h3 {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 27px;\n  color: #979797 !important;\n  margin: 0;\n}\n.WLSettings .addCatField,\n.WLSettings .addPlacementField {\n  position: relative;\n}\n.WLSettings .addCatField .btn,\n.WLSettings .addPlacementField .btn {\n  position: absolute;\n  right: 3px;\n}\n.WLSettings .catCols .form-group {\n  position: relative;\n  padding: 28px 0;\n}\n.WLSettings .catCols .form-group span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n.WLSettings .placementCols {\n  padding: 12px 10px;\n  border-bottom: 1px solid #f2f2f2;\n}\n.WLSettings .placementCols .fa-code {\n  font-size: 20px;\n  color: #dbdbdb;\n}\n.WLSettings .catImageCol {\n  width: 30px;\n  overflow-x: hidden;\n  position: relative;\n  display: flex;\n  align-items: center;\n  z-index: 0;\n  height: auto;\n}\n.WLSettings .catImageCol i.fa-upload {\n  position: absolute;\n  right: 0;\n  left: 0;\n  z-index: -1;\n  max-width: 100%;\n  height: auto;\n  text-align: center;\n}\n.WLSettings .catImageCol span.close {\n  top: -5px;\n  right: -1px;\n}\n.WLSettings .catTextCol {\n  max-width: 32%;\n}\n.WLSettings .catTextCol input[type=\"text\"],\n.WLSettings .placementCols input[type=\"text\"] {\n  border: none;\n  background: transparent;\n}\n.WLSettings .catReorderCol {\n  width: 25px;\n  overflow-x: hidden;\n  text-align: right;\n}\n.WLSettings .catCols {\n  border-bottom: 1px solid #f2f2f2;\n}\n.WLSettings .catCols i {\n  color: #dbdbdb;\n  font-size: 20px;\n}\n.inline-toggles .form-group {\n  width: 33%;\n  display: inline-block;\n  vertical-align: bottom;\n  text-align: center;\n}\n\n.inline-fieldGroups .form-group {\n  width: 50%;\n  display: inline-block;\n  vertical-align: bottom;\n  text-align: left;\n}\n.WLSettings .catCols input.form-control-file {\n  opacity: 0;\n  cursor: pointer;\n}\n\n.WLSettings .field-logo {\n  width: 100%;\n  height: 15vw;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.WLSettings .field-favicon {\n  width: 100%;\n  height: 10vw;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.WLSettings .field-emaillogo {\n  width: 100%;\n  height: 10vw;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.img-field-wrap {\n  position: relative;\n  width: 100%;\n  height: 7vw;\n}\n.img-field-wrap input[type=\"file\"] {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n.img-field-wrap img,\n.img-field-placeholder {\n  position: absolute;\n  z-index: 0;\n  text-align: center;\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  flex-direction: column;\n}\n.img-field-wrap span.close {\n  position: absolute;\n  right: 10px;\n  top: 3px;\n  z-index: 1;\n  color: #dbdbdb;\n  cursor: pointer;\n}\n.img-field-placeholder * {\n  display: block;\n  color: #dbdbdb;\n}\n.img-field-placeholder i {\n  font-size: 18px;\n}\n.img-field-placeholder span {\n  font-size: 14px;\n  line-height: 18px;\n}\n.img-field-placeholder .upload-label {\n  color: #2f80ed;\n}\n\n.joinedNetworksWrap {\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n  padding-bottom: 1px;\n  min-height: 42px;\n}\n.joinedNetworksWrap:hover {\n  overflow-x: scroll;\n}\nspan.joinedNetworks {\n  display: inline-flex;\n  border: 1px solid #e7e7e7;\n  border-radius: 4px;\n  background: #fff;\n  padding: 5px 10px;\n  margin-right: 7px;\n  margin-bottom: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  font-size: 14px;\n  align-items: center;\n}\nspan.joinedNetworks input[type=\"radio\"] {\n  opacity: 0;\n  position: absolute;\n}\nspan.joinedNetworks i,\nspan.joinedNetworks img,\nspan.joinedNetworks svg {\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  border-radius: 100%;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.joinedNetworksWrap input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n}\ninput[type=\"radio\"]:checked + span.joinedNetworks {\n  background: #2f80ed;\n  color: #ffffff;\n}\n\n.deleteUser {\n  color: #e33628;\n  font-size: 18px;\n  cursor: pointer;\n}\n\nmain.collapsed .main-left-col {\n  width: 85px;\n  padding: 0;\n}\nmain.collapsed .main-right-col {\n  width: calc(100% - 100px);\n  overflow-x: auto;\n}\n\nmain.collapsed aside,\nmain.collapsed aside nav ul li {\n  text-align: center !important;\n}\nmain.collapsed aside nav ul li a span,\nmain.collapsed aside nav ul li h2 {\n  display: none;\n}\nmain.collapsed aside nav ul li a {\n  padding-left: 10px;\n  text-align: center;\n  display: block;\n  border: 0px solid transparent !important;\n}\nmain.collapsed aside nav.leftMenu ul {\n  margin-left: -15px;\n}\nmain.collapsed aside nav ul li .menuToggle {\n  transform: rotate(180deg);\n  margin-left: 0 !important;\n}\nmain.collapsed aside .current-network-section .dropdown button.dropdown-toggle {\n  font-size: 0;\n  padding: 8px 5px !important;\n  width: 30px;\n}\nmain.collapsed\n  aside\n  .current-network-section\n  .dropdown\n  button.dropdown-toggle:after {\n  position: static !important;\n  font-size: 12px;\n}\nmain.body.collapsed .current-network-section {\n  padding-right: 0.25rem !important;\n}\nmain.body.collapsed aside nav ul li i,\nmain.body.collapsed aside nav ul li svg {\n  margin-right: 0;\n}\n\n.badge {\n  border-radius: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n.badge-success {\n  color: #fff;\n  background: #2aa974;\n}\n.badge-primary {\n  color: #fff;\n  background-color: #007bff;\n}\n.badge-danger {\n  color: #fff;\n  background-color: #dc3545;\n}\n.badge-light {\n  color: #212529;\n  background-color: #e4e4e4;\n}\n.mr1 {\n  margin-right: 4px;\n}\n.debateTitle9 {\n  color: #9b9b9b;\n  font-size: 11px;\n}\n.debateTitle9 svg.svg,\ntable.tableCommon td .debateTitle9 svg.svg {\n  width: 12px !important;\n  height: 12px !important;\n  color: #d8d8d8;\n}\na.linkActive {\n  color: #2f80ed;\n}\na.linkInactive {\n  color: #bdbdbd !important;\n  cursor: context-menu;\n  border-color: #bdbdbd !important;\n  pointer-events: none;\n}\n\n.datePickerWrapper {\n  position: relative;\n}\n.datePickerWrapper i {\n  position: absolute;\n  right: 10px;\n  top: calc(50% - 8px);\n}\n.startDebate .buttons .btn {\n  width: 50%;\n  padding: 15px;\n}\n.startDebate .form-control.datepickerField {\n  padding-left: 10px;\n  padding-right: 32px;\n}\n.startDebate .form-control {\n  padding: 8px;\n  background: #ffffff;\n  font-size: 13px;\n  line-height: 19px;\n  font-family: \"Open sans\";\n}\n.startDebate .side .form-control {\n  border: 0px solid #999;\n  border-left-width: 5px;\n  border-radius: 5px;\n  padding: 9px;\n  padding-right: 60px;\n}\n.startDebate .side .form-control.removeBtnOn {\n  padding-right: 120px;\n}\n.startDebate .side {\n  padding-bottom: 10px;\n}\n.startDebate .side .message {\n  padding: 12px 14px;\n  background: #f5f5f5;\n  border-radius: 4px;\n}\n.startDebate textarea.form-control[name=\"background\"] {\n  height: 120px;\n}\n.startDebate textarea.form-control {\n  max-height: 120px !important;\n}\n.startDebate .field-backgroundImage {\n  width: 100%;\n  height: 7vw;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f6f6f6;\n  max-height: 235px;\n  position: absolute;\n}\n.startDebate .delete-side {\n  /*position: absolute;\n  right: 5px;\n  top: 0;*/\n}\n.startDebate .delete-button {\n  font-size: 11px;\n  font-weight: 400;\n}\n.startDebate .sideP {\n  padding-right: 60px;\n}\n.startDebate .sideP + i {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 10px;\n  color: #bdbdbd;\n}\n.startDebate .side-inline-items {\n  position: absolute;\n  right: 7px;\n  top: 6px;\n  height: 100%;\n}\n.addNetworkField input[type=\"text\"] {\n  border: none;\n  background: #f6f6f6;\n}\n.searchWrapper {\n  position: relative;\n}\n.searchResultList {\n  position: absolute;\n  left: 0;\n  right: 0;\n  background: #f6f6f6;\n  padding: 10px;\n  max-height: 124px;\n  overflow: hidden;\n  overflow-y: auto;\n}\n.loading *,\n.formSubmitting * {\n  pointer-events: none !important;\n}\n\n.modal-body {\n  max-width: 100%;\n}\n.modalContentWrapper {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.votesPercentage {\n  position: absolute;\n  right: 10px;\n  top: 0;\n  font-size: 13px;\n  font-weight: 600;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.percentageBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n}\nlabel .fa-lock {\n  font-size: 17px;\n  color: #9b9b9b;\n  margin-left: 5px;\n}\n.debatePreviewSection {\n  padding: 25px 0;\n  background: #f6f6f6;\n  border-radius: 10px;\n}\n.debatePreviewInner {\n  border-radius: 10px;\n  background: #ffffff;\n  padding: 20px;\n  box-shadow: 0px 0px 6px 0px #0000001a;\n  max-width: 334px;\n  margin: 0 auto;\n}\n.debatePreviewBgImg img {\n  max-width: 100%;\n  border-radius: 6px;\n  border: 1px solid #e7e7e7;\n  padding: 0px;\n  height: 150px;\n  width: 100%;\n  object-fit: cover;\n}\n.debatePreviewTitle h5,\n.debatePreviewSides label {\n  color: #333333 !important;\n}\n.debatePreviewTitle p {\n  padding: 7px;\n  background: #efefef;\n  margin-bottom: 7px;\n}\n.lightColorSpan {\n  font-size: 13px;\n  font-weight: 400;\n  color: #9b9b9b;\n  line-height: 18px;\n  font-family: \"Open Sans\";\n}\n.lightColorSpan.large {\n  font-size: 16px;\n}\n.lightColorSpan.small {\n  font-size: 11px;\n}\na.lightColorSpan:hover {\n  color: #2f80ed;\n}\n.debatePreviewSides label {\n  text-align: center;\n  border: 1px solid #60a4e9;\n  border-radius: 10px;\n  padding: 7px;\n}\n.debatePreviewAdunit {\n  width: 300px;\n  height: 250px;\n  margin: 0 auto;\n  background: #eaeaea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9b9b9b;\n  max-width: 100%;\n}\n.debatePreviewFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid #e8e8e8;\n  padding-top: 10px;\n}\n.debatePreviewFooter img {\n  width: auto;\n  height: 15px;\n}\n.topDebateHeader .arrow svg {\n  width: 20px;\n  height: 20px;\n  color: #d8d8d8;\n  margin-left: 10px;\n}\n.topDebatesTitle svg {\n  background: #ff3206;\n  background: linear-gradient(180deg, #ff3206 0, #fda103);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ff3206\",endColorstr=\"#fda103\",GradientType=0);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.topDebatesSection,\n.suggestedDebatesSection,\n.smartPollSection {\n  background: #f6f6f6;\n  border-radius: 8px;\n  padding: 20px;\n}\n.topDebatesContent,\n.smartPollContent {\n  white-space: nowrap;\n  width: 100%;\n  overflow: auto;\n  padding-bottom: 1px;\n  min-height: 42px;\n  max-height: 460px;\n}\n.topDebatesContent *,\n.smartPollContent * {\n  white-space: initial;\n}\n.topDebate,\n.smartPollContent .debatePreviewInner {\n  display: inline-block;\n  margin-right: 20px;\n  background: #ffffff;\n  vertical-align: top;\n  box-shadow: 0 0px 6px 0px #0000001a;\n  border-radius: 8px;\n  width: 32%;\n  max-width: 334px;\n}\n.topDebate.relative {\n  position: relative;\n}\n.topDebateSides {\n  margin-bottom: 5px;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  color: #4a4a4a;\n  border-left-style: solid;\n  border-left-width: 5px;\n  border-radius: 3px;\n  padding: 8px;\n  padding-right: 60px;\n  overflow-wrap: break-word;\n}\n.assetsCount {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.assetsCount li {\n  width: 49%;\n  display: inline-block;\n  font-size: 13px;\n  color: #9b9b9b;\n}\n.assetsCount.suggDeb li {\n  width: 100%;\n  display: block;\n}\n.assetsCount li span {\n  font-size: 14px;\n  color: #000000;\n}\n.fa-plus-circle-blue {\n  color: #2f80ed;\n  background: #ffffff;\n  border-radius: 100%;\n  border: 1px solid #ffffff;\n}\na.publishButton {\n  border: 1px solid #2f80ed;\n  border-radius: 4px;\n  background: rgb(67 165 245 / 10%);\n  padding: 4px 12px;\n  color: #2f80ed;\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.debates .faArrowAltCircleRight {\n  font-size: 18px;\n  color: #d8d8d8;\n}\n.align-item-center {\n  align-items: center;\n}\n.loadingBarWrap {\n  width: 100vw;\n  height: 5px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999999999;\n  background: gray;\n}\n.loadingBar {\n  width: 20vw;\n  height: 5px;\n  background: green;\n  position: relative;\n  animation: mymove 5s infinite ease-in-out;\n}\n@keyframes mymove {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: 80vw;\n  }\n  100% {\n    left: 0;\n  }\n}\n\nsection.closed form.startDebate input,\nsection.closed form.startDebate select,\nsection.closed form.startDebate textarea,\nsection.closed form.startDebate .close {\n  pointer-events: none !important;\n}\n.networkSettingsTabs {\n  border: none !important;\n}\n.networkSettingsTabs .nav-link {\n  font-weight: 600;\n  font-size: 18px;\n  color: #9b9b9b;\n  border: none;\n  border-radius: 0;\n  line-height: 19px;\n  padding: 0 25px 0;\n  border-right: 2px solid #9b9b9b;\n}\n.networkSettingsTabs .nav-link.active,\n.networkSettingsTabs .nav-link:focus,\n.networkSettingsTabs .nav-link:hover {\n  border-color: #9b9b9b;\n}\n.networkSettingsTabs .nav-link:first-child {\n  padding: 0 25px 0 0;\n}\n.networkSettingsTabs .nav-link:last-child {\n  padding: 0 0 0 25px;\n  border-right: none;\n}\n.integrationSettingsTab {\n  width: 100%;\n  max-width: 800px;\n}\n.integrationSettingsTab label.form-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a4a4a;\n  margin-bottom: 5px;\n  margin-top: 25px;\n}\n.integrationSettingsTab h3 {\n  font-size: 18px;\n  color: #979797;\n  margin-bottom: 10px;\n}\n.integrationSettingsTab p {\n  font-size: 13px;\n  margin-bottom: 10px;\n  color: #4a4a4a;\n}\n.integrationSettingsTab hr {\n  margin: 30px 0;\n}\n.integrationSettingsTab .form-control {\n  background: #f6f6f6;\n  border-color: #f6f6f6;\n  -webkit-appearance: menulist;\n}\n.integrationSettingsModal h3 {\n  font-weight: 700;\n  font-size: 22px;\n  color: #000000;\n}\n.placementNameWrap {\n  position: relative;\n}\n.placementNameWrap a {\n  position: absolute;\n  bottom: 4px;\n  right: 0;\n  font-size: 13px;\n  padding: 10px 15px;\n}\ninput[type=\"text\"].apiKey {\n  background: #ffffff;\n}\n.apiKeyAnchors a {\n  margin-right: 15px;\n  padding-right: 15px;\n  border-right: 1px solid #d8d8d8;\n}\na.disable {\n  pointer-events: none;\n}\na.enable {\n  color: #2f80ed;\n}\n.enable {\n  cursor: pointer;\n}\n.usernamePlaceholder {\n  margin-bottom: 0;\n  background: #efefef;\n  line-height: 17px;\n}\n.createUserContent form label {\n  font-size: 12px;\n  font-weight: 500;\n}\n.createUserContent form .form-group {\n  border-bottom: 0 !important;\n  padding-bottom: 0 !important;\n}\n.createUserContent form #password {\n  padding-right: 130px;\n}\n.generatePassword {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 10px;\n}\n.topDebatesContentWrapper {\n  position: relative;\n}\n.sdLoading {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  font-size: 18px;\n  text-align: right;\n  background: #ffffff;\n  /* padding: 5px 10px; */\n  box-shadow: -20px 0px 50px 20px #fff;\n  display: flex;\n  align-items: center;\n}\n.domainsField input {\n  padding-right: 75px;\n}\n.domainsField span {\n  position: absolute;\n  right: 15px;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n}\n.disabledInput {\n  opacity: 0.5 !important;\n  pointer-events: none !important;\n}\n.customSlideToggle {\n  transition: all ease-in-out 0.5s;\n  max-height: 280px;\n  overflow: auto;\n}\n.customSlideToggle.collapsed {\n  max-height: 0;\n  /*opacity: 0;*/\n  overflow: hidden;\n}\n.custom-select-wrapper {\n  z-index: 1;\n}\n\n.custom-select {\n  list-style: none;\n  background: #fff;\n  margin: 0;\n  padding: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: all ease-in-out 0.3s;\n  width: 100%;\n  z-index: 1054;\n  border: 1px solid #999999;\n  border-top: 0;\n  margin-top: -5px;\n  padding-top: 10px;\n}\n.custom-select.dropdown-expand {\n  max-height: 60vh;\n  opacity: 1;\n  overflow-y: auto;\n  height: auto;\n}\n.custom-select li {\n  padding: 0px 10px;\n  cursor: pointer;\n}\n.custom-select li:hover,\n.custom-select li.active {\n  background: #f2f2f2;\n}\n.custom-select li hr {\n  display: block;\n  padding: 0;\n  margin: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.custom-select li *,\n.custom-select-head * {\n  display: inline-block;\n  vertical-align: middle;\n}\n.custom-select li img,\n.custom-select-head img {\n  width: 26px;\n  height: 26px;\n  border-radius: 0;\n  margin-right: 10px;\n}\n.custom-select li p,\n.custom-select-head p {\n  line-height: 15px;\n  font-size: 14px;\n}\n.custom-select li p small,\n.custom-select-head p small {\n  color: #999999;\n  font-size: 12px;\n  display: block;\n}\n.custom-select-head {\n  background: #ffffff;\n  border: none;\n  padding: 4px 10px;\n  display: block;\n  width: 100%;\n  min-width: 300px;\n  text-align: left;\n  border-radius: 5px;\n  position: relative;\n  z-index: 1055;\n  border: 1px solid #999999;\n  border-bottom: 0;\n  cursor: pointer;\n}\n.custom-select-head svg {\n  position: absolute;\n  right: 15px;\n  height: 100%;\n  top: 0px;\n  z-index: -1;\n}\n\n.customBtn {\n  border-color: #2f80ed;\n  color: #2f80ed;\n  font-size: 14px;\n  background: #ffffff;\n  width: auto !important;\n  line-height: 18px;\n  white-space: nowrap;\n}\n.customBtn.customBtnBlue {\n  background: #2f80ed !important;\n  color: #ffffff !important;\n}\n.customBtn:hover {\n  color: #ffffff;\n  background: #2f80ed;\n}\n.deployeDebateTable tr td {\n  border: none;\n}\n.deployeDebateTable tr td a svg {\n  margin-bottom: 2px;\n}\n.debStat {\n  background: #f2f2f2;\n  border-radius: 10px;\n  padding-bottom: 10px;\n  transition: all ease-in-out 0.5s;\n  width: 100%;\n}\n.debStat table {\n  margin: 0;\n}\n.tableCommon.debates tr th:first-child,\n.debStat table tr th:first-child {\n  width: 55%;\n  overflow-wrap: anywhere;\n}\n.deployeDebateTable .title-td {\n  width: 47%;\n  overflow-wrap: anywhere;\n}\n.debStat table td {\n  padding: 8px 0;\n}\n.debStat.collapsed {\n  background: #fafafa00;\n}\n.debStat > div > a {\n  width: auto;\n  min-width: 160px;\n  height: 30px;\n  text-align: center;\n  background: #f2f2f2;\n  padding: 2px 15px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.debStat > div {\n  padding: 10px 0px;\n  transition: all ease-in-out 0.5s;\n}\n.debStat.collapsed > div {\n  padding: 0;\n}\n.debStat.collapsed .customSlideToggle {\n  max-height: 0;\n  /*opacity: 0;*/\n  overflow: hidden;\n}\n.customSlideToggle {\n  transition: all ease-in-out 0.5s;\n  max-height: 280px;\n  overflow: auto;\n  margin: 0px 20px 0px 30px;\n}\n#publish-debate-section {\n  min-height: 100vh;\n}\n.depToPagesList {\n  max-height: 110px;\n  overflow: auto;\n}\nhr.customHr {\n  margin-top: 40px;\n  margin-bottom: 30px;\n}\n.userAvatarWrapper input,\n.userCoverImageWrapper input {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.profileForm .userAvatarWrapper {\n  width: 105px;\n  height: 105px;\n  border-radius: 100%;\n  border: 1px dashed #828282;\n  padding: 5px;\n  object-fit: cover;\n}\n.profileForm .userAvatar {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  object-fit: cover;\n}\n.profileForm .userAvatarPlaceholder {\n  background: #f2f2f2;\n  display: block;\n  height: 100%;\n  border-radius: 100%;\n}\n.profileForm .userCoverImageWrapper {\n  /*border: 1px dashed #828282;\n  padding: 5px;*/\n  /*width: 100%;*/\n  /*min-height: 210px;*/\n  /*display: flex;\n  align-items: center;\n  justify-content: center;*/\n  overflow: hidden;\n}\n.profileForm .userCoverImage {\n  height: auto;\n  object-fit: cover;\n  max-height: 200px;\n  border: 1px dashed #828282;\n  padding: 5px;\n  max-width: 100%;\n}\n.profileForm .userCoverImagePlaceholder {\n  background: #f2f2f2;\n  height: 150px;\n  border: 1px dashed #828282;\n  padding: 5px;\n  display: block;\n}\n.profileForm .hasIcon i {\n  position: absolute;\n  left: calc(50% - 9px);\n  top: calc(50% - 9px);\n  color: #ffffff;\n  /*box-shadow: 0 0 15px 1px #000000;*/\n  padding: 0;\n}\n.embedPlacement .fa-check-circle {\n  width: 16px !important;\n  height: 16px;\n}\n.embedPlacement td svg {\n  color: #dbdbdb;\n}\n.embedPlacement td.active svg {\n  color: #2aa974;\n}\n.placementPreviewSection {\n  display: flex;\n}\n\n.placementPreviewSection {\n  box-shadow: 0px 0px 6px 0px #0000001a;\n}\n.placementPreviewSection.top {\n  flex-direction: column;\n}\n.placementPreviewSection.right {\n  flex-direction: row-reverse;\n}\n.placementPreviewSection.bottom {\n  flex-direction: column-reverse;\n}\n.placementPreviewSection.left {\n  flex-direction: row;\n}\n.placementPreviewSection.top,\n.placementPreviewSection.bottom {\n  width: 300px;\n}\n.placementPreviewSection .debateSection {\n  width: calc(100% - 400px);\n}\n.placementPreviewSection.top .debateSection,\n.placementPreviewSection.bottom .debateSection {\n  width: 100%;\n}\n.placementPreviewSection .adSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.placementPreviewSection .adSection span {\n  font-weight: 700;\n  font-size: 36px;\n  color: #ffffff;\n  font-family: \"Open Sans\";\n  display: block;\n  background: #2f80ed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.placementPreviewSection .adSection span {\n  width: 400px;\n  height: 300px;\n}\n.placementPreviewSection.top .adSection span,\n.placementPreviewSection.bottom .adSection span {\n  width: 300px;\n  height: 250px;\n}\n.placementPreviewSection .debatePreviewInner {\n  max-width: inherit;\n  border-radius: 0;\n  box-shadow: none;\n}\nselect.networkId option {\n  padding: 10px 8px;\n  font-size: 13px;\n  font-weight: 400;\n  font-family: \"Open Sans\";\n  border-radius: 2px;\n}\n.AddNetworkToGroupForm,\n.AddUserToGroupNetworkForm,\n.AddNewNetworkForm,\n.AddUserToGroupForm {\n  margin: 0 auto;\n  width: 350px;\n}\n.AddNetworkToGroupForm .btn,\n.AddUserToGroupNetworkForm .btn,\n.AddNewNetworkForm .btn,\n.AddUserToGroupForm .btn {\n  width: 49%;\n}\np.userNameSection {\n  font-size: 32px;\n  font-weight: 400;\n  font-family: \"Open Sans\";\n}\np.userNameSection small {\n  color: #9b9b9b;\n  font-size: 14px;\n  display: block;\n}\n.groupNetworkUsersTable .toggle-checkbox {\n  float: none;\n}\n.groupNetworkUsersTable .toggle-checkbox:before {\n  width: 46px;\n  height: 25px;\n  top: -6px;\n}\n.groupNetworkUsersTable .toggle-checkbox:after {\n  width: 21px;\n  height: 21px;\n  top: -4px;\n}\n.advanceUserSettingsModal .modalContentWrapper {\n  max-width: 100%;\n}\n\n.updateGroupUserSettingsForm table {\n  vertical-align: middle;\n}\n.updateGroupUserSettingsForm table .form-group {\n  padding: 5px 0;\n}\n.updateGroupUserSettingsForm table tr:last-child td {\n  border: none;\n}\n.currentEditedGroupName input {\n  font-size: 14px;\n  font-weight: 600;\n  width: 400px;\n  padding-right: 105px;\n}\n.currentEditedGroupName .editGroupNameBtns {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 15px;\n}\n.brandAccountWrap {\n  padding: 20px 15px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n}\n.addGroupModal h5 {\n  font-family: \"Verdana\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: #333333;\n}\ninput.toggle-checkbox.disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.7;\n}\n.sidedFavicon {\n  width: 50px;\n  height: 50px;\n  margin: 0 auto;\n  display: block;\n  margin-bottom: 17px;\n}\nform.AddNewNetworkForm input[type=\"text\"] {\n  padding: 13px 10px;\n}\nform.AddNewNetworkForm #subDomainPostFix {\n  margin-left: -3px;\n  width: auto;\n  display: inline-block;\n  width: 90px;\n}\n.searchResultBar {\n  width: 250px;\n}\n.anchorLikeTabs {\n  border: none;\n}\n.anchorLikeTabs a.nav-link {\n  border: none;\n  font-size: 14px;\n  font-weight: 400;\n  color: #2f80ed;\n  line-height: 15px;\n  background: none !important;\n}\n.anchorLikeTabs a.nav-link.active {\n  color: #9b9b9b;\n  cursor: default;\n}\n\n.current-network-section .dropdown.show .dropdown-menu {\n  width: 100%;\n  max-height: 250px;\n  overflow: auto;\n  box-shadow: 0px 0px 10px -5px #000;\n}\n\nmain.body aside .dropdown button:after {\n  color: #9b9b9b;\n  position: absolute;\n  border-top: 0.5em solid;\n  border-right: 0.5em solid transparent;\n  border-bottom: 0;\n  border-left: 0.5em solid transparent;\n  top: calc(50% - 3px);\n  right: 15px;\n}\n.overlappedH3 {\n  position: absolute;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  z-index: -1;\n}\ntable.networksAdBreakdown th {\n  font-size: 13px;\n  text-transform: inherit;\n}\n.btn.side-link,\n.btn.side-tag {\n  border: 1px solid #e0e0e0;\n  background: #ffffff;\n  min-width: 38px;\n  padding: 8px;\n  color: #bdbdbd;\n}\n.btn.side-link.active,\n.btn.side-tag.active {\n  background: #bdbdbd;\n  color: #ffffff;\n}\n.btn.side-link:disabled,\n.btn.side-tag:disabled {\n  background: #bdbdbd;\n  color: #ffffff;\n  opacity: 1;\n}\n.sideLink,\n.sideTags {\n  padding: 5px;\n  background: #e8e8e8;\n  border-radius: 4px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  font-family: \"Open Sans\";\n  line-height: 16px;\n}\n.sideLink a {\n  color: #0a58ca;\n  text-decoration: underline;\n}\n.sideLink svg,\n.sideTags svg {\n  width: 13px !important;\n  color: #bdbdbd;\n  margin-right: 6px;\n  margin-left: 7px;\n}\n.flip {\n  transform: scaleX(-1);\n}\n.add-link-tag-wrapper {\n  width: calc(100% - 90px);\n}\n.add-link-tag-wrapper .sideElementsButtons {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  padding: 4px;\n  align-items: center;\n}\n.add-link-tag-wrapper svg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  margin: 10px;\n  color: #bdbdbd;\n}\n.add-link-tag-wrapper input {\n  border: 1px solid #ced4da !important;\n  padding-right: 140px;\n}\n.sideElementsButtons button {\n  width: 62px;\n  height: 28px;\n}\n.nav-tabs .nav-link.disabled {\n  color: #bdbdbd;\n}\n.CreateDebateTabs.nav-tabs .nav-link {\n  padding: 18px 38px;\n  font-size: 12px;\n  font-family: \"Open Sans\";\n  font-weight: 600;\n}\n.CreateDebateTabs.nav-tabs .nav-link:not(.active) {\n  background: #f5f5f5;\n  border: 1px solid #dee2e6;\n  color: #2f80ed;\n}\n.CreateDebateTabs.sm.nav-tabs .nav-link {\n  padding: 10px 16px;\n}\n\n.rightColCustomPos {\n  position: relative;\n  top: -70px;\n}\n.fa-secondary {\n  color: #828282;\n}\n.customDropdown button {\n  width: 100%;\n  background: #fff !important;\n  color: #4e4e4e !important;\n  padding: 7px 14px;\n  border-color: #dbdbdb !important;\n  text-align: left;\n  font-size: 13px;\n  font-family: \"Open Sans\";\n  word-break: break-word;\n  white-space: break-spaces;\n  font-weight: 600 !important;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.customDropdown button.dropdown-toggle {\n  padding-right: 30px;\n}\n.customDropdown button:after,\n.standard-dropdown button:after {\n  color: #9b9b9b;\n  border-top: 0.5em solid;\n  border-right: 0.5em solid transparent;\n  border-left: 0.5em solid transparent;\n  top: calc(40%);\n  position: absolute;\n  right: 10px;\n}\n.customDropdown .dropdown-menu {\n  width: 140%;\n  max-height: 250px;\n  overflow: auto;\n}\n.customDropdown .dropdown-menu .dropdown-item {\n  padding: 5px 10px !important;\n  word-break: break-word !important;\n  white-space: break-spaces;\n  font-weight: 600 !important;\n  font-family: \"Open Sans\";\n  font-size: 13px;\n}\n.embedDomainPageTags {\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 300px;\n}\n.embedDomainPageTags:hover {\n  overflow-x: auto !important;\n}\n.embedDomainPageTags .btn:hover {\n  box-shadow: none;\n  cursor: auto;\n}\n.deployActions a {\n  display: inline-block;\n  max-width: 30%;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n}\n.smartPollWrapper {\n  padding: 15px 18px;\n  background: #f5f5f5;\n  border-radius: 10px;\n  margin: 10px 0 30px 0;\n}\n\n.smartPollContent .debatePreviewInner {\n  width: 53%;\n  max-width: 250px;\n  margin-right: 10px;\n}\n.smartPollContent h6.usernamePlaceholder {\n  width: 90px;\n  line-height: 13px;\n}\n.smartPollContent span.usernamePlaceholder {\n  width: 65px;\n  display: block;\n  margin-top: 4px;\n  line-height: 9px;\n}\n.smartPollContent .img-circle.avatar {\n  height: 30px;\n  width: 30px;\n  min-width: 30px;\n}\n.smartPollContent h6 {\n  line-height: 14px;\n  font-size: 14px;\n}\n.smartPollContent .debatePreviewTitle h6 {\n  line-height: 18px;\n}\n.smartPollContent .debatePreviewSides label {\n  font-size: 11px !important;\n  line-height: 15px !important;\n  border-radius: 8px;\n  padding: 5px;\n}\n.smartPollContent .debatePreviewInner > div:not(.debatePreviewAdunit),\n.smartPollContent .debatePreviewInner > span {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.smartPollSection .cssload-container {\n  position: relative;\n  width: auto;\n  text-align: center;\n}\n.smartPollSection div.author .small-dp svg {\n  height: 0.8em;\n}\n.selectPollBtn {\n  padding: 5px;\n  font-size: 12px;\n  margin-left: 0px;\n}\n\ntable.audience-table {\n  border-collapse: separate;\n}\ntable.audience-table tr:first-child {\n  position: sticky;\n  top: 82px;\n  background: white;\n  font-weight: bold;\n  z-index: 1;\n}\n\n.reported-cases-stats label {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 16px;\n}\n.otherReportsHeader svg {\n  width: 25px;\n  height: 25px;\n  color: #c4c4c4;\n  cursor: pointer;\n}\n.otherReportsFooter .reportedBy {\n  font-size: 14px;\n  color: #4f4f4f;\n}\n.reportedBy svg {\n  width: 16px;\n  height: 16px;\n  color: #bdbdbd;\n  margin-right: 10px;\n}\nh6 small,\nh5 small {\n  color: #828282;\n  font-weight: 400;\n  display: block;\n  font-size: 12px;\n}\n.report-text {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  font-family: \"Open Sans\";\n  background: #f9f9f9;\n  border-radius: 5px;\n  padding: 10px 13px;\n  margin: 10px 0;\n  word-break: break-word;\n}\n.report-text-wrap label {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n.report-text-wrap .side label {\n  font-size: 12px;\n  color: #000000 !important;\n}\n.report-text-wrap .debatePreviewInner {\n  max-width: 100%;\n  box-shadow: none;\n  padding-top: 0;\n}\n.report-text-wrap .debatePreviewInner > div:not(.debatePreviewAdunit),\n.report-text-wrap .debatePreviewInner > span {\n  padding: 0;\n}\n.report-text-wrap h5 {\n  font-weight: 700;\n}\n.reprted-profile {\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.reprted-profile-author-wrapper {\n  position: relative;\n  min-width: 95px;\n  min-height: 90px;\n}\n.reprted-profile-author {\n  position: absolute;\n  top: -60px;\n}\n.reprted-profile-author .img-circle.avatar {\n  width: 87px;\n  height: 87px;\n}\n.reprted-profile-author .username {\n  color: #2f80ed;\n}\n.user-profile-info {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  font-family: \"Open Sans\";\n  padding: 10px 13px;\n}\n.user-profile-info .bolder {\n  font-weight: 600;\n}\n.user-profile-info .bolder b {\n  font-weight: 700 !important;\n}\n.user-profile-cover {\n  height: 110px;\n}\n.user-profile-cover img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\ndiv.reprted-profile-author .small-dp svg {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  background: #ffffff;\n  border-radius: 100%;\n  height: 25px;\n}\n.radioAsBtns .form-check {\n  padding: 0;\n  position: relative;\n}\n.radioAsBtns input[type=\"radio\"] {\n  opacity: 1;\n  position: absolute;\n  right: 40%;\n  z-index: -1;\n}\n.radioAsBtns label {\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  line-height: 17px !important;\n  text-align: center;\n  border: 1px solid #e0e0e0;\n  color: #2f80ed !important;\n  border-radius: 4px;\n  padding: 7px 8px;\n  margin-right: 6px;\n  background: #ffffff;\n}\n.radioAsBtns input[type=\"radio\"]:checked + label {\n  background: #2f80ed !important;\n  color: #ffffff !important;\n  border-color: #2f80ed !important;\n}\n.otherReportsWrapper {\n  /*display: none;*/\n}\n.otherReportsWrapper:before {\n  opacity: 0;\n  content: \"1\";\n  transition: all ease-in-out 0.3s;\n}\n.otherReportsWrapper.show:before {\n  opacity: 1;\n  content: \"1\";\n  width: 100vw;\n  height: 100vh;\n  background: rgb(0 0 0 / 50%);\n  z-index: 99999;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n.otherReports {\n  width: 450px;\n  height: 100vh;\n  overflow: none;\n  position: fixed;\n  right: -450px;\n  top: 0;\n  bottom: 0;\n  background: #ffffff;\n  z-index: 999999;\n  transition: all ease-in-out 0.3s;\n  display: flex;\n  flex-direction: column;\n}\n.otherReports .report-text {\n  margin-bottom: 30px;\n}\n.otherReportsWrapper.show .otherReports {\n  right: 0px;\n}\n.otherReportsBody .debatePreviewInner {\n  padding-bottom: 0;\n}\n.otherReportsBody .report-text {\n  margin-bottom: 0;\n}\n.otherReportsFooter {\n  box-shadow: inset 0px 15px 15px -15px rgb(0 0 0 / 25%);\n}\n.otherReportsScroller {\n  overflow: auto;\n}\n.moderationTabs {\n  border: 1px solid #e1e1e1;\n  display: flex;\n  border-radius: 5px;\n}\n.moderationTabs span {\n  color: #2f80ed;\n  padding: 12px 15px;\n  font-size: 13px;\n  line-height: 16px;\n  font-family: \"Open Sans\";\n  cursor: pointer;\n}\n.moderationTabs span:first-child {\n  border-right: 1px solid #e1e1e1;\n}\n.moderationTabs span.active {\n  background: #f7f7f7;\n  color: #828282;\n  cursor: default;\n}\n.lockedSuspendStatus {\n  font-size: 12px;\n  font-family: \"Open Sans\";\n  line-height: 16px;\n  padding: 6px 6px 6px 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  color: #4f4f4f;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 150px;\n}\n.lockedSuspendStatus svg {\n  color: #bdbdbd;\n  height: 15px;\n  margin-left: 10px;\n}\n.arrowBelowAuthor {\n  position: relative;\n}\n.arrowBelowAuthor:before {\n  content: \"\";\n  position: absolute;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg width='16' height='37' viewBox='0 0 16 37' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.5 36.5L16 31L10.5 25.5L9.09 26.91L12.17 30L6.5 30C4 30 2.00001 28 2.00001 25.5L2 -8.74228e-08L0 0L6.99382e-06 25.5C7.15075e-06 29.09 2.91 32 6.5 32L12.17 32L9.08 35.09L10.5 36.5Z' fill='%23E0E0E0'/%3E%3C/svg%3E%0A\");\n  width: 20px;\n  background-repeat: no-repeat;\n  left: calc(50% - 1px);\n  height: 100%;\n  background-position: left bottom;\n  bottom: -55px;\n}\n.arrowBelowAuthor:after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  left: calc(50% - 1px);\n  background: #e0e0e0;\n  margin-top: 5px;\n}\n.otherReports .arrowBelowAuthor:before {\n  margin-top: 5px;\n  top: 100%;\n}\n.otherReports .arrowBelowAuthor:after {\n  display: none;\n}\nspan.reportType {\n  position: relative;\n}\nspan.reportType:after {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background: #4f4f4f;\n  position: absolute;\n  left: 0;\n  bottom: 2px;\n  opacity: 0.4;\n}\nbutton:disabled {\n  opacity: 0.2;\n}\n.segments .sorting {\n  margin-top: 40px;\n}\n.analytic-stats .card-body,\n.advertising-stats .card-body {\n  padding: 0.5rem 1rem 1rem 1rem;\n}\n.custom-dropdown-search {\n  top: 0px;\n  padding: 8px;\n  position: sticky;\n  background: #fff;\n}\n.custom-dropdown-search input {\n  font-size: 13px;\n}\n\n.form-control:focus {\n  box-shadow: none !important;\n}\n.supportLink {\n  font-weight: 400;\n  color: #ffff !important;\n}\n.supportLink:hover {\n  text-decoration: underline;\n}\n@media (min-width: 1320px) {\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl {\n    max-width: 1500px;\n  }\n}\n\n/*@media (min-width: 1025px) {\n  ::-webkit-scrollbar {\n    height: 8px;\n    width: 10px;\n  }\n\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 0 5px #e0e0e0;\n    border-radius: 0px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #bbbbbb;\n    border-radius: 0px;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #aaaaaa;\n  }\n}*/\n\n@media (max-width: 1366px) {\n  main.body section {\n    padding-left: 20px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .container {\n    max-width: 96%;\n    width: 100%;\n  }\n  main.body section h2 {\n    font-size: 25px;\n  }\n}\n@media (max-width: 1024px) {\n  main.body section {\n    padding-left: 0px;\n  }\n}\n\n.sided-tabs {\n  display: flex;\n  justify-content: center;\n}\n.sided-tabs nav {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.sided-tabs nav .nav-link {\n  color: #333;\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 0;\n  padding: 12px 22px;\n  border-right: 1px solid #ddd;\n}\n.sided-tabs nav .nav-link:last-child {\n  border-right: 0 none;\n}\n.main-category {\n  cursor: pointer;\n  position: relative;\n}\n.main-category.active:after {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: \"\";\n  position: absolute;\n  border-radius: 8px;\n  border: 3px solid #2f80ec;\n}\n.main-category h1 {\n  margin: 0;\n}\n.main-category small {\n  opacity: 0.7;\n}\n\n.toggle-side {\n  opacity: 0.35;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 700;\n}\n.toggle-side.active {\n  opacity: 1;\n}\n.toggle-side + .toggle-checkbox {\n  margin: 0 22px;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.sided-id.toggle-checkbox:before,\n.sided-id.toggle-checkbox:checked:before {\n  background: #2f80ec;\n}\n.sided-id.toggle-checkbox:after {\n  box-shadow: none;\n}\n\n.toggleSidebarVisibility .menuToggle {\n  width: 35px;\n  height: 23px;\n  transition: all ease-in-out 0.3s;\n}\n\n/* Responsive styles */\n.toggleSidebarVisibility {\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 82px;\n  display: flex;\n  width: 60px;\n  align-items: center;\n  justify-content: center;\n  transition: all ease-in-out 0.3s;\n}\n.main-left-col .toggleSidebarVisibility {\n  position: static;\n  background: #3a3a3a;\n  width: calc(100% + 17px);\n  margin-left: -15px;\n  justify-content: left;\n  padding-left: 28px;\n}\nbody.menuVisible .main-left-col {\n  left: 0;\n}\n@media (min-width: 768px) {\n  .toggleSidebarVisibility {\n    display: none;\n  }\n  .pull-right-lg {\n    float: right;\n  }\n}\n@media (max-width: 767px) {\n  .blue-button.size-l {\n    height: 43px !important;\n    padding: 0 20px !important;\n  }\n  main.collapsed .main-right-col {\n    width: 100vw;\n    overflow-x: inherit;\n  }\n  .WLSettings .field-logo {\n    height: 50vw;\n  }\n  .WLSettings .field-favicon,\n  .WLSettings .field-emaillogo {\n    height: 25vw;\n  }\n  .WLSettings .buttons {\n    position: static;\n    text-align: center;\n  }\n  .apiKeyAnchors {\n    width: 100%;\n    overflow: auto;\n    padding-bottom: 10px;\n  }\n  main.body section {\n    padding-top: 30px;\n    margin-bottom: 50px;\n  }\n  .networkSettingsTabs {\n    flex-flow: nowrap;\n    overflow: auto;\n    padding-bottom: 15px;\n  }\n  .networkSettingsTabs a {\n    text-wrap: nowrap !important;\n  }\n  .WLSettings h3 {\n    margin-top: 10px !important;\n  }\n  .WLSettings > .col-md-6 {\n    padding: 0 !important;\n  }\n  .general-stats {\n    display: block !important;\n    background: none !important;\n    margin-bottom: 0 !important;\n    padding-top: 0 !important;\n  }\n  .general-stats > div {\n    border: none !important;\n    background: #f6f6f6 !important;\n    display: inline-block;\n    width: 47% !important;\n    padding: 20px 10px;\n  }\n  .general-stats > div:nth-child(2n + 1) {\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .section-title {\n    margin-bottom: 0 !important;\n  }\n  .table-holder {\n    width: 1100px;\n  }\n  .table-cell {\n    white-space: nowrap;\n  }\n  .audience-table .table-cell,\n  .table-cell a {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    padding: 10px !important;\n  }\n  .table-filters {\n    display: block !important;\n  }\n  .table-pagination {\n    justify-content: space-between;\n  }\n  .table-search {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n  .analytic-stats {\n    margin: 0 !important;\n  }\n  .analytic-stats .col-lg-3 {\n    width: 47.5%;\n    padding: 0px;\n  }\n  .analytic-stats .col-lg-3:nth-child(2n + 1) {\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .advertising-stats > div {\n    width: 47.5%;\n    padding: 0px;\n  }\n  .advertising-stats > div:nth-child(2n + 1) {\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .advertising-stats .card-body {\n    padding: 1rem 2rem !important;\n  }\n  header .navbar-brand {\n    margin-left: 45px;\n  }\n  .main-left-col {\n    position: fixed;\n    top: 0px;\n    left: -270px;\n    background: #ffffff;\n    z-index: 99;\n    height: 100vh;\n    transition: all ease-in-out 0.3s;\n  }\n  .menuVisible .main-left-col {\n    box-shadow: 0 0 10px 6px #000000;\n  }\n  .menuCollapseToggle {\n    display: none;\n  }\n  body main.body:after {\n    content: \"\";\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 100vh;\n    background: #000000cc;\n    z-index: 90;\n    transition: all ease-in-out 0.3s;\n  }\n  body.menuVisible main.body:after {\n    width: 100vw;\n  }\n  body.menuVisible {\n    overflow: hidden !important;\n  }\n  .title-section {\n    display: block !important;\n    margin-bottom: 30px !important;\n  }\n  .mobile-block {\n    display: block;\n  }\n  .mobile-block form#search {\n    margin-bottom: 20px;\n  }\n  .table-wrapper {\n    width: 100vw;\n    overflow: auto;\n    max-width: 100%;\n  }\n  .networksAdBreakdown {\n    width: 600px;\n  }\n  .networksAdBreakdown .w-50 {\n    width: auto !important;\n  }\n  .groupNetworkUsersTable {\n    width: 500px;\n  }\n  table.audience-table tr:first-child {\n    position: static;\n  }\n  .segments .sorting {\n    margin-top: 15px;\n  }\n  .segments .sorting .table-filters-start {\n    margin-bottom: 15px;\n  }\n  .debates.tableCommon {\n    width: 670px;\n  }\n  .topDebate,\n  .smartPollContent .debatePreviewInner {\n    width: 100%;\n    margin-right: 15px;\n    max-width: 275px;\n  }\n  .topDebatesSection,\n  .suggestedDebatesSection,\n  .smartPollSection {\n    padding: 15px 10px;\n  }\n  .footer-left-col {\n    display: block;\n    text-align: center;\n  }\n  .footer-right-col {\n    justify-content: center;\n    margin-top: 10px;\n  }\n  table.embedPlacement {\n    width: 100%;\n    min-width: 580px;\n  }\n  .currentEditedGroupName input {\n    width: 180px;\n    padding-right: 8px;\n  }\n  .currentEditedGroupName .editGroupNameBtns {\n    position: static;\n    padding: 5px;\n  }\n  .btn {\n    padding: 10px 20px;\n  }\n  .rightColCustomPos {\n    position: static;\n  }\n  .startDebate .field-backgroundImage {\n    height: 30vw;\n  }\n  .img-field-wrap {\n    height: auto;\n  }\n  .startDebate .img-field-wrap,\n  .startDebate .field-backgroundImage,\n  .startDebate .img-field-wrap img,\n  .startDebate .img-field-placeholder,\n  .startDebate .img-field-wrap button {\n    position: static !important;\n  }\n  table.network-users {\n    width: 750px;\n  }\n  body.menuVisible main.collapsed aside {\n    /*height: calc(100vh - 82px);*/\n  }\n  .placementPreviewSection.right,\n  .placementPreviewSection.left {\n    width: 700px;\n  }\n  .add-link-tag-wrapper {\n    width: 100%;\n  }\n  .segment-form-body {\n    padding: 15px !important;\n  }\n  .segment-form-condition .select-box,\n  .segment-form-condition .input-box {\n    margin: 4px 5px 4px 0 !important;\n  }\n  .modal-close-btn {\n    font-size: 24px;\n    padding: 0 10px;\n  }\n  .modal-body {\n    margin: 15px auto;\n  }\n  .AuthorSettings .buttons {\n    position: static;\n  }\n  .common-form .buttons .btn-secondary,\n  .common-form .buttons .btn-primary {\n    margin-top: 25px;\n  }\n  .createUserContent form .form-group:first-child {\n    padding-top: 0px !important;\n  }\n  .moderationTabs {\n    display: inline-flex;\n    margin-top: 15px;\n  }\n  .reported-cases-body .btn-outline-secondary,\n  .reported-cases-body .btn-primary {\n    min-width: 190px;\n  }\n  .authorModal .network-list-row {\n    /*width: 500px;*/\n    flex-wrap: wrap;\n    padding: 15px 0px !important;\n  }\n  .customDropdown .dropdown-menu {\n    max-width: 100%;\n  }\n  p.userNameSection {\n    font-size: 24px;\n    margin-bottom: 0;\n  }\n  .AddNetworkToGroupForm,\n  .AddUserToGroupNetworkForm,\n  .AddNewNetworkForm,\n  .AddUserToGroupForm {\n    width: 100% !important;\n  }\n  .auth-box {\n    padding: 18px !important;\n    width: 91% !important;\n  }\n  .auth-box form .text-line {\n    white-space: inherit !important;\n  }\n  footer .footer-right-col ul {\n    margin-left: 0 !important;\n    padding-left: 0 !important;\n  }\n  .auth-box form fieldset.code-fields + .end-option {\n    margin-bottom: 50px !important;\n  }\n  .for-stickies {\n    padding: 100px 0 90px !important;\n  }\n  .authContainer header .navbar-brand {\n    margin: 20px;\n    text-align: center;\n    display: block;\n  }\n  .table-control .table-control-dropdown {\n    left: -8px !important;\n    max-width: 56vw !important;\n    padding: 5px !important;\n  }\n  .table-control .table-control-dropdown ul li {\n    padding: 5px 5px !important;\n  }\n  .auth-box form fieldset .two-fields {\n    display: block !important;\n  }\n  .auth-box form fieldset .two-fields > div {\n    width: 100% !important;\n  }\n  .profileForm {\n    margin-top: 25px;\n  }\n  .reprted-profile-author-wrapper {\n    min-height: 70px;\n  }\n  .user-profile-info {\n    padding: 10px 9px;\n  }\n  .otherReports {\n    width: 100vw;\n    right: -100vw;\n    display: block;\n    overflow: auto;\n  }\n  .sided-modal-body {\n    padding: 15px !important;\n  }\n  .reprted-profile-author {\n    top: -40px;\n  }\n  .reprted-profile-author .img-circle.avatar {\n    width: 60px;\n    height: 60px;\n  }\n  .user-profile-cover {\n    height: 90px;\n  }\n  .AuthorSettings .form-group {\n    padding: 25px 10px !important;\n  }\n  .common-form:not(.AuthorSettings, .DeployDebateForm) label:not(.sub-label) {\n    font-size: 12px;\n  }\n  .network-list-name {\n    flex: 1 0 75%;\n  }\n  .network-list-count {\n    flex: 1 0 25%;\n  }\n  .network-list-buttons {\n    text-align: left !important;\n    margin: 15px 0 0 20px;\n  }\n  .network-list-buttons > * {\n    margin-bottom: 10px;\n  }\n  .network-list-id {\n    overflow-wrap: anywhere;\n  }\n  div.author .copy-wrap {\n    overflow-wrap: anywhere;\n  }\n  div.reprted-profile-author .small-dp svg {\n    left: 42px;\n    height: 18px;\n  }\n}\n.infinite-scroll-component__outerdiv .infinite-scroll-component .infinite-loading {\n  padding: 5px;\n}\n.poll-box {\n    color: #333;\n    font-size: 15px;\n    overflow: hidden;\n    padding: 8px 12px;\n    position: relative;\n    border-radius: 5px;\n    background: transparent;\n    justify-content: space-between;\n    border: 0;\n    border-left: 5px solid transparent;\n    display: flex;\n    line-height: 1.3;\n    text-align: center;\n    margin-bottom: 5px;\n    align-items: center;\n}\n.poll-box .full-side-bar {\n  position: absolute;\n  opacity: .08;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n}\n.poll-box .overlay-box {\n  opacity: .1;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 0;\n}\n.poll-box .poll-text {\n  position: relative;\n  margin-right: 55px;\n  text-align: left;\n  z-index: 3;\n}\n.poll-percent {\n  top: 50%;\n  padding: 0;\n  z-index: 3;\n  right: 16px;\n  font-size: 13px;\n  text-align: right;\n  position: absolute;\n  transform: translateY(-50%);\n}\n.react-datepicker__month.react-datepicker__monthPicker .react-datepicker__month-wrapper{\n  padding: 3px;\n  font-size: 12px;\n}\n.react-datepicker__month-text--keyboard-selected:not([aria-disabled=\"true\"]):hover {\n  color: white;\n}\n.react-datepicker__month .react-datepicker__month-text, .react-datepicker__month .react-datepicker__quarter-text {\n  line-height: 20px\n}\n.view-poll-box {\n  width: 350px;\n  margin-right: 0px;\n}\n.view-poll-box.last-step {\n  width: 700px;\n}\n.view-poll-box.last-step .debatePreviewSection1 {\n  width: 350px;\n}\n.view-poll-box.last-step .react-flow__handle-bottom {\n  left: 25%;\n}\n.view-poll-box .debatePreviewInner {\n  max-width: unset;\n}\n.user-option-selected-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.user-option-header {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n}\n.remove-button {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #2F80ED;\n  cursor: pointer;\n}\n.option-container {\n  border: 1px solid #E0E0E0;\n  min-height: 40px;\n  border-radius: 4px;\n  color: #4A4A4A;\n  padding: 8px;\n}\n.step-number {\n  width: 100%;\n  height: 20px;\n  margin-right: 0px;\n}\n.add-step-branch-group {\n  display: flex;\n  gap: 1px;\n  margin-top: 8px;\n  justify-content: center;\n}\n.add-branch-image {\n  margin: 0px;\n  height: 12px;\n  width: 12px;\n  font-size: 18px;\n  line-height: 1;\n}\n.add-step-container {\n  height: 100px;\n  width: 300px;\n}\n.add-step-button-container {\n  width: 300px;\n  height: 20px;\n  margin-right: 0px;\n}\n.add-step-button {\n  border-radius: 20px;\n  padding: 5px 5px;\n  margin: 0px;\n  height: 40px;\n  width: 40px;\n  font-size: 18px;\n  line-height: 1;\n}\n.react-flow__handle {\n  opacity: 0;\n}\n.debatePreviewVotes {\n  display: grid;\n  gap: 15px;\n  grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));\n  grid-auto-rows: minmax(100px, auto);\n  align-items: center;\n  margin-top: 10px;\n}\n\n.vote-container {\n  position: relative;\n  height: 138px;\n  min-width: 138px;\n}\n\n.vote-image-container {\n  overflow: hidden;\n}\n\n.vote-image-container img {\n  width: 100%;\n  height: 138px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n.vote-overlay {\n  position: absolute;\n  height: 23px;\n  z-index: 1;\n  opacity: 0.7;\n  bottom: 10px;\n  background: rgba(255, 255, 255, 0.7);\n  width: 90%;\n  display: flex;\n  left: 5%;\n  border-radius: 100px;\n  gap: 5px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.vote-text {\n  max-width: 65%;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  margin-left: 30px;\n}\n\n.vote-percentage {\n  width: 35%;\n  font-weight: 700;\n  font-size: 11px;\n  text-align: right;\n  margin-right: 5px;\n}\n\n.check-icon {\n  border-radius: 50%;\n  bottom: 10px;\n  height: 23px;\n  width: 23px;\n  left: 7px;\n  position: absolute;\n  opacity: 1;\n  background: rgba(255, 255, 255, 0.7);\n  text-align: center;\n  color: #E0E0E0;\n}\n.debate-image-web {\n  display: block; /* Default state */\n}\n\n@media (max-width: 768px) {\n  .debate-image-web {\n    display: none;\n  }\n}\n.debate-image-mobile {\n  display: none; /* Default for non-mobile screens */\n}\n\n@media (max-width: 768px) {\n  .debate-image-mobile {\n    display: flex; /* Show as flex on mobile */\n    gap: 5px;\n    background-color: rgb(245, 245, 245);\n    padding-bottom: 10px;\n    padding-right: 10px;\n    border-radius: 4px;\n  }\n}\n.network-admin-toggle {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.network-admin-toggle div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.network-admin-toggle div .form-check-label {\n  margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
